/*
https://closure-compiler.appspot.com/home
https://obfuscator.io/

・命名ルール：
　アプリ共通：c(common), アプリ個別・モジュール共通：i(individual), アプリ個別・モジュール個別：p(paticular) or _(underscore)

・map のメリットは、処理結果を即配列に代入できること、記述が簡素化されること

・map はスキップされるため await を必要に応じて使用する

・map の引数関数を async する場合は、await Promise.all で map を括る必要がある
  await Promise.all(_ld_iss.map(async _d_is => {
    return await _o_fnc();
  }));

・promise の結果は、スコープの広い変数を用いて共有する

・pck の初期化 は -1 で行う

・this.$osr は処理が循環しないよう、データの流れに注意する（幹から枝へ処理する）、原則として fld の更新のみに使用し、load の代替としては使用しない

・sgc_pageKey は iv.load において設定しない（iv.load は 複数モジュールで使用されるため）

・setState を同時並行で実施した場合、処理が適切に行われない場合がある

・アップグレード時の対応事項


・コンポーネントの作り方
　・state で 仮のデータを作る
　・コンポーネントの表示機能を作成し仮のデータを表示する（select）
　・仮のデータを変更可能とする（update）
　・仮のデータを追加登録可能とする（insert）
　・仮のデータを削除可能とする（delete）

・immer は本体の差し替えには対応していないもよう
・immer による代入と、通常の代入は混在できないもよう
・配列コンポーネントにおいて、変更前後で key が異なる場合、コンポーネントが正しく入れ替わらない事になる

・iphone では margin / padding を top/bottom/left/right の別に指定する必要がある
・要素には、必ず、階層ごとにユニークな key を設定すること

・function や state を介したコンポーネントは、state の変更や共有が正しく行われないことがある ＞ RN の伝搬ルールを理解する必要がある

・stl は別に分ける必要がありそう

・シンプルなプログラム構造とする
・複数関数をまたいだ listener は実行されない模様、component から直接関数を呼び出す必要がある
・値は、this.state.am1a1020 で参照、引数は構造体となっており直接値を参照できない
・複数のモーダルを切り替えて画面遷移させることはできない模様、その場合、コンポーネントを分けるか、overlay か、ほかのダイアログの使用を検討か？
・起動直後に落ちる場合は、import に正しく名前が設定されているか、import されてない要素が render で使われていないか、無効なコンポートがApp.jsでインポートされていないか、c.jsx に無効な関数が含まれていないか
・alert は 2 以上同時に表示されることはないらしい
・encountered two childre with the same key は、複数のコンポーネントで class 名が重複している場合に発生？
・javascript
  0 == false, 1 == true, _l.update = _l.push, _d.update = _d.assign
・動かない理由は、関数名が誤っている、let/const がついていない
・Value for title can not be cast from double to string
　→ title の "" を '' に変える
・callable function の中で class の this は機能しない
・for 文の後の処理は平行して実行される　→ myCM_for_each2 を使用
・Possible unhandled promise rejection
　→ then の後は同じ型のデータを返す catch を必ずつける
・function 中の this において state は無効、全て _o_this として引用
・this.state において state の付け忘れがないかを確認
×setState は 変数ベースでは機能せず、必ず、{} で変更対象の状態変数を具体的に記載する必要がある模様
・setState を用いた際は、await したいと状態の同期がとれない場合がある
・react native や 関連するモジュールの仕様が変更され、従来の設定では正しく動作しなくなる場合があることに注意
・状態変数がコンポーネントの引数に含まれていない場合、状態変化は伝搬しない模様

// common program として実現したいこと
* 選択されたメニューをハイライト表示する？
* 画面を遷移した際に、pageName と pageKey を push & delete する　－＞ javascript の push / pop を使えばよい
済　* 画面を遷移した際に、状態変数を全てクリアする


expo upgrade

// for common
expo install immer
expo install base-64
expo install lz-string
expo install moment
expo install papaparse
expo install utf8
expo install buffer

// for native
expo install @react-native-async-storage/async-storage
expo install @react-navigation/native
expo install @react-navigation/stack
expo install expo-av
expo install expo-constants
expo install expo-document-picker
expo install expo-file-system
expo install expo-image-picker
expo install expo-media-library
expo install expo-permissions
expo install expo-sharing
expo install react-native-gesture-handler
expo install react-native-mime-types
expo install react-native-screens
expo install react-native-ticker
expo install react-native-unimodules
expo install react-native-vector-icons
expo install victory-native
expo install react-native-svg

// for web
expo install file-saver
expo install react-dropzone
expo install victory
expo install file-saver

//expo install expo-updates
//expo install expo-intent-launcher
//expo install react-native-step-indicator
//expo install react-native-paper
//expo install react-native-calendars
//expo install react-navigation
//expo install react-navigation-stack
//expo install modal-enhanced-react-native-web
//expo install react-native-icon-badge
//expo install react-native-modal
//expo install react-native-picker-select
*/



// for myRN
import { 
  Alert,
  Keyboard,
  Linking, 
  Platform, 
  StatusBar,
//    StyleSheet,
  Dimensions,
} from "react-native"; 

// for myLS
//import AsyncStorage from '@react-native-community/async-storage'
import AsyncStorage from '@react-native-async-storage/async-storage'

// for expo
import Constants from 'expo-constants';
import * as DocumentPicker from 'expo-document-picker';
import * as FileSystem from 'expo-file-system';
import * as ImagePicker from 'expo-image-picker';
//import * as IntentLauncher from 'expo-intent-launcher';
import * as Permissions from 'expo-permissions';
import * as Sharing from 'expo-sharing';
//import * as Updates from 'expo-updates';
import * as MediaLibrary from 'expo-media-library';
import * as Clipboard from 'expo-clipboard';

/*
import {
    Constants,
    //DocumentPicker,
    Permissions,
    ImagePicker,
    Updates,
    FileSystem,
} from 'react-native-unimodules' // for react-native
*/

import * as mime from 'react-native-mime-types'; // for mimeType


//import Papa from 'papaparse';

import { bf } from './bf';
import { ic } from './ic';

//import { cp } from './cp';

import { iv } from './iv';
import { df } from './df';

export class cf { // common function
    
  //////////////////////////////////////////////////////////////////////// for callback

  static myCB_call_eml(p_eml, p_sbj, p_msg){ // 汎用メール送信
    return new Promise((resolve)=>{
      let _ld_valss = [
        {key:'data', vals:{ usr:'-1', tkn:'', ctr:'send', prc:'', vwi:'', idc:'/', fld:'',
          val:{eml:p_eml, sbj:p_sbj, msg:p_msg},
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss,
      })
      .then((_a_res) => {
        resolve(_a_res);
      });
    });
  };

  static myCB_call_nmb(p_eml){ // 指定したメールアドレスへの確認番号の送信
    return new Promise((resolve)=>{
      let _ld_valss = [
        {key:'data', vals:{ usr:'-1', tkn:'', ctr:'eml', prc:'', vwi:'', idc:'/', fld:'',
          val:{eml:p_eml},
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        resolve(_a_res);
      });
    });
  };

  static myCB_call_cnf(p_eml, p_nmb){ // 確認番号の確認
    return new Promise((resolve)=>{
      let _ld_valss = [
        {key:'data', vals:{ usr:'-1', tkn:'', ctr:'cnf', prc:'', vwi:'', idc:'/', fld:'',
          val:{eml:p_eml, nmb:p_nmb},
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        resolve(_a_res);
      });
    });
  };

  static myCB_call_dwl = (pd={
    elm: '', 
    tgt: '',
  }) => new Promise( _o_end1 =>{
    let _ld_valss = [
      {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'dwl', ctr:'', prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
        tgt:pd.tgt,
      }},
    ];
    cf.myCR_xhr({
      mode: 'POST',
      url: ic.g_url1,
      ld_valss: _ld_valss
    })
    .then((_a_res) => {
      if (bf.f(_a_res)) {
        cf.myRN_open_url('{}/{}'.f(ic.g_url2, _a_res.file))
        .then( () => {
          _o_end1(_a_res);
        });
      }
      else {
        _o_end1(null);
      }
    });
  });

/*
  static myCB_call_iud = (p_ctr, p_elm, pd_vals, p_cnd='', p_qry='', pl_qrys=[]) => new Promise( async _o_end1 => {
    if (p_ctr == 'qrys') {
      for await (let [_idx, _qry] of bf.e(pl_qrys)) {
        let _ld_valss = [
          {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:'qry', prc:'', vwi:'', idc:'{}/'.f(p_elm), fld:'',
            val:pd_vals,
            cnd:p_cnd,
            qry:_qry,
          }},
        ];
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        });
      }
      _o_end1();
    }
    else if (p_ctr == 'ins'){
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:p_ctr, prc:'', vwi:'', idc:'{}/'.f(p_elm), fld:'',
          val:pd_vals,
          cnd:p_cnd,
          qry:p_qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        global.c?.setState({ // ins 時は自動的に d_oos に ins値が設定される
          sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
            _next['d_{}s'.f(p_elm)] = _a_res;
          }),
        }, () => {
          _o_end1(_a_res);
        });
      });
    }
    else {
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:p_ctr, prc:'', vwi:'', idc:'{}/'.f(p_elm), fld:'',
          val:pd_vals,
          cnd:p_cnd,
          qry:p_qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        _o_end1(_a_res);
      });
    };
  });
*/
  static myCB_call_iud = (pd={
    ctr: '', 
    elm: '', 
    d_vals: {}, 
    cnd: '', 
    qry: '', 
    l_qrys: []
  }) => new Promise( async _o_end1 => {
    if (pd.ctr == 'qrys') {
      for await (let [_idx, _qry] of bf.e(pd.l_qrys)) {
        let _ld_valss = [
          {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:'qry', prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
            val:pd.d_vals,
            cnd:pd.cnd,
            qry:_qry,
          }},
        ];
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        });
      }
      _o_end1();
    }
    else if (pd.ctr == 'ins'){
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:pd.ctr, prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
          val:pd.d_vals,
          cnd:pd.cnd,
          qry:pd.qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        global.c?.setState({ // ins 時は自動的に d_oos に ins値が設定される
          sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
            _next['d_{}s'.f(pd.elm)] = _a_res;
          }),
        }, () => {
          _o_end1(_a_res);
        });
      });
    }
    else {
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'iud', ctr:pd.ctr, prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
          val:pd.d_vals,
          cnd:pd.cnd,
          qry:pd.qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        _o_end1(_a_res);
      });
    };
  });

/*
  static myCB_call_slc = (pd={
    ctr: 'nlm/qry', 
    elm: '', 
    n_dms: 0, 
    cnd: '', 
    qry: '', 
    do_rfrs: null, 
    dld_pcksss: null, 
    d_cashs: null,
    ld_sortss: [{fld:'key', dtn:'asc'}],
  }) => new Promise( _o_end1 => {
    if (
      pd.d_cashs && 
      pd.d_cashs[pd.cnd]
    ) { // キャッシュが指定されており、キャッシュが存在する場合
      _o_end1(pd.d_cashs[pd.cnd])
    }
    else {
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'slc', ctr:pd.ctr, prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
          dms: pd.n_dms,
          cnd: pd.cnd,
          qry: pd.qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then( async _a_res => {
        //
        if (pd.n_dms == 3) {
          //
          let _l = [];
          //
          let _dd_cashss = {};
          if (pd.do_rfrs){ // rfrs が定義されている場合
            for await (let [_elm, _cnd] of bf.e(pd.do_rfrs)) {
              _dd_cashss[_elm] = {};
            }
          };
          //
          for await (let [_idx, _d_vals] of bf.e(_a_res)) {
            //
            let _d_vals2 = {};
            //
            if (bf.f(pd.do_rfrs)){ // rfrs が定義されている場合
              for await (let [_elm, _o_cnd] of bf.e(pd.do_rfrs)) {
                let _cnd = _o_cnd(_d_vals);
                if (bf.f(_cnd)) {
                  await cf.myCB_call_slc({
                    ctr: 'nlm', 
                    elm: _elm, 
                    n_dms: 2, 
                    cnd: _cnd,
                    d_cashs: _dd_cashss[_elm],
                  })
                  .then( _d_vals3 => {
                    if (bf.f(_d_vals3)) { // データが存在した場合
                      _d_vals2 = bf.myCM_upd(_d_vals2, _d_vals3);
                    };
                  });
                };
              };
            };
            //
            _d_vals2 = bf.myCM_upd(_d_vals2, _d_vals);
            //
            if (bf.f(pd.dld_pcksss)){ // pcks が定義されている場合
              for await (let [_fld, _ld_pckss] of bf.e(pd.dld_pcksss)) { // _d_defs.pcks は通常の pcks と同形式であること {key:{key:'', pfx:''}}
                if (_d_vals2[_fld] && bf.myCM_get_dct({ld_itemss:_ld_pckss, fld:'key', val:_d_vals2[_fld]})) {
                  _d_vals2[_fld] = bf.myCM_get_dct({ld_itemss:_ld_pckss, fld:'key', val:_d_vals2[_fld]}).pfx;
                }
              };
            };
            //
            _l.push(_d_vals2)
          };
          _a_res = _l;
          let _a_res2 = bf.myCM_sort({
            ld_itemss: _a_res, 
            ld_sortss: pd.ld_sortss,
          });
          //
          if (pd.d_cashs){ // キャッシュが指定されている場合
            pd.d_cashs[pd.cnd] = _a_res;
          }
          _o_end1(_a_res2);
        }
        else {
          if (pd.d_cashs){ // キャッシュが指定されている場合
            pd.d_cashs[pd.cnd] = _a_res;
          }
          _o_end1(_a_res);
        };
      });
    }
  });
*/

  static myCB_call_slc = (pd={
    ctr: 'nlm/qry', 
    elm: '', 
    n_dms: 0, 
    cnd: '', 
    qry: '', 
    do_rfrs: null, 
    dd_rfrss: null,
    dld_pcksss: null, 
//    d_cashs: null,
    dd_cashss: null,
    ld_sortss: [{fld:'key', dtn:'asc'}],
  }) => new Promise( _o_end1 => {
    if (
      pd.dd_cashss && 
      pd.dd_cashss[pd.elm] && 
      pd.dd_cashss[pd.elm][pd.cnd]
    ) { // キャッシュが指定されており、キャッシュが存在する場合
//      _o_end1(pd.d_cashs[pd.cnd])
      _o_end1(pd.dd_cashss[pd.elm][pd.cnd])
    }
    else {
      let _ld_valss = [
        {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'slc', ctr:pd.ctr, prc:'', vwi:'', idc:'{}/'.f(pd.elm), fld:'',
          dms: pd.n_dms,
          cnd: pd.cnd,
          qry: pd.qry,
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then( async _a_res => {
        //
        if (pd.n_dms == 3) {
          //
          let _l = [];
          //
          let _dd_cashss = {};
//          if (pd.do_rfrs){ // rfrs が定義されている場合
//            for await (let [_elm, _cnd] of bf.e(pd.do_rfrs)) {
//              _dd_cashss[_elm] = {};
//            }
//          };
          //
          for await (let [_idx, _d_vals] of bf.e(_a_res)) {
            //
            let _d_vals2 = {};
            //
            if (bf.f(pd.do_rfrs)){ // rfrs が定義されている場合
              for await (let [_elm, _o_cnd] of bf.e(pd.do_rfrs)) {
                let _cnd = _o_cnd(_d_vals);
                if (bf.f(_cnd)) {
                  await cf.myCB_call_slc({
                    ctr: 'nlm', 
                    elm: _elm, 
                    n_dms: 2, 
                    cnd: _cnd,
                    dd_cashss: _dd_cashss,
                  })
                  .then( _d_vals3 => {
                    if (bf.f(_d_vals3)) { // データが存在した場合
                      _d_vals2 = bf.myCM_upd(_d_vals2, _d_vals3);
                    };
                  });
                };
              };
            };

            if (bf.f(pd.dd_rfrss)){ // rfrs が定義されている場合
              await Promise.all(
                Object.keys(pd.dd_rfrss)
                .map( _als => new Promise( _o_end2 => {
                  let _elm = pd.dd_rfrss[_als].elm;
                  let _cnd = pd.dd_rfrss[_als].o_cnd(_d_vals);
                  if (_cnd) {
                    cf.myCB_call_slc({
                      ctr: 'nlm', 
                      elm: _elm, 
                      n_dms: 2, 
                      cnd: _cnd,
                      dd_cashs: _dd_cashss,
                    })
                    .then( _d_vals3 => {
                      if (bf.f(_d_vals3)) { // データが存在した場合
                        _d_vals2['{}_key'.f(_als)]=_d_vals3._KEY;
                        Object.keys(_d_vals3)
                        .filter( _fld => bf.i(_fld, ['_KEY', '_UGR', '_DLT']) ? false : true )
                        .map( _fld => {
                          _d_vals2['{}{}'.f(_als, _fld.substr(4,4))] = _d_vals3[_fld];
                        });
                        _o_end2();
                      }
                      else {
                        _o_end2();
                      };
                    });
                  }
                  else{
                    _o_end2();
                  };
                }))
              );
            };

            _d_vals2 = bf.myCM_upd(_d_vals2, _d_vals);
            //
            if (bf.f(pd.dld_pcksss)){ // pcks が定義されている場合
              for await (let [_fld, _ld_pckss] of bf.e(pd.dld_pcksss)) { // _d_defs.pcks は通常の pcks と同形式であること {key:{key:'', pfx:''}}
                if (_d_vals2[_fld] && bf.myCM_get_dct({ld_itemss:_ld_pckss, fld:'key', val:_d_vals2[_fld]})) {
                  _d_vals2[_fld] = bf.myCM_get_dct({ld_itemss:_ld_pckss, fld:'key', val:_d_vals2[_fld]}).pfx;
                }
              };
            };
            //
            _l.push(_d_vals2)
          };
          _a_res = _l;
          let _a_res2 = bf.myCM_sort({
            ld_itemss: _a_res, 
            ld_sortss: pd.ld_sortss,
          });
          //
//          if (pd.d_cashs){ // キャッシュが指定されている場合
//            pd.d_cashs[pd.cnd] = _a_res;
          if (pd.dd_cashss){ // キャッシュが指定されている場合
            if (bf.f(pd.dd_cashss[pd.elm]) == false) pd.dd_cashss[pd.elm] = {};
            pd.dd_cashss[pd.elm][pd.cnd] = _a_res;
          }
          _o_end1(_a_res2);
        }
        else {
//          if (pd.d_cashs){ // キャッシュが指定されている場合
          if (pd.dd_cashss){ // キャッシュが指定されている場合
//            pd.d_cashs[pd.cnd] = _a_res;
            if (bf.f(pd.dd_cashss[pd.elm]) == false) pd.dd_cashss[pd.elm] = {};
            pd.dd_cashss[pd.elm][pd.cnd] = _a_res;
          }
          _o_end1(_a_res);
        };
      });
    }
  });

static myCB_call_tree = (pd={
  ctr: 'slc/iud',
  dd_prtss: {},
  dd_elmDefss: {
    als: { // alias
      elm: '',
      n_dms: 2, // slc
      cnd: '',
      o_cnd: _dd_prtss => '',
      dd_cldDefss: { // same with dd_elms
      },
      o_atr: () => {} // after
    },
  },
  dd_cashss: {},
  state: '',
}) => new Promise( _o_end1 => {

  let _dd_cashss = pd.dd_cashss || {};
  
  const _o_slc = (pd2={
    als: '', // alias
    dd_prtss: {},
    d_defs: {},
  }) => new Promise( _o_end3 => {

    let _n_dms = (pd2.d_defs.n_dms) ? pd2.d_defs.n_dms : 3;
    let _cnd = pd2.d_defs.cnd || pd2.d_defs.o_cnd(pd2.dd_prtss || {});
    let _dd_rfrss = pd2.d_defs.dd_rfrss || {};
    let _ld_sortss = pd2.d_defs.ld_sortss || [
      { fld: '{}cz10'.f(pd2.d_defs.elm), dtn: 'desc', mode: 'nmb' },
      { fld: '{}cx10'.f(pd2.d_defs.elm), dtn: 'asc', mode: 'nmb' },
      { fld: '{}cw10'.f(pd2.d_defs.elm), dtn: 'asc', mode: 'str' },
    ]; // 標準のソート条件

    cf.myCB_call_slc({
      ctr: 'nlm',
      elm: pd2.d_defs.elm,
      n_dms: _n_dms,
      cnd: _cnd,
      dd_rfrss: _dd_rfrss,
      ld_sortss: _ld_sortss,
      dd_cashss: _dd_cashss,
    })
    .then( async _a_rs => {

      if ( _n_dms == 2 ) {
//bf.l('665: {}'.f(pd2.als))
        let _d_elms = { 
          elm: pd2.d_defs.elm || '',
          key: _a_rs._KEY || -1,
          idx: 0,
          d_flds: _a_rs,
          dd_stgss: {},
          b_upd: false,
          b_new: false,
          b_dlt: false,
          b_hideCld: false, // hide child
          dld_cldDatsss: {},
//          dd_prtss: pd2.dd_prtss,
        };

//        let _dd_prtss = bf.c(pd2.dd_prtss || {}, {[pd2.als]:_d_is.d_flds}); // alias ごとに分ける, 複製であることに留意
//        let _dd_prtss = bf.c(pd2.dd_prtss || {}, {[pd2.als]:_d_is}); // alias ごとに分ける, 複製であることに留意
        let _dd_prtss = bf.c(pd2.dd_prtss || {}, {[pd2.als]:_a_rs}); // alias ごとに分ける, 複製であることに留意
//        if (pd2.d_defs.op_act) await pd2.d_defs.op_act(pd2.dd_prtss);
//bf.l('705: here')
        if (pd2.d_defs.op_act) await pd2.d_defs.op_act(_dd_prtss);
//bf.l('707: here')
        if (bf.f(pd2.d_defs.dd_cldDefss) == true) {
          Promise.all(
            Object.keys(pd2.d_defs.dd_cldDefss)
            .map( _cld => new Promise( _o_end4 => {
              let _d_defs = pd2.d_defs.dd_cldDefss[_cld];
              _o_slc({
                als: _cld,
                dd_prtss: _dd_prtss,
                d_defs: _d_defs,
              })
              .then( _a_rs2 => {
                _d_elms.dld_cldDatsss[_cld] = _a_rs2;
                _o_end4();
              });
            }))
          )
          .then(() => {
            _o_end3(_d_elms);
          });
        }
        else {
          _o_end3(_d_elms);
        };
      }; 

      if ( _n_dms == 3 ) {
        let _ld_elmss = _a_rs
        .map( (_d_rs, _idx) => {
          return { 
            elm: pd2.d_defs.elm || '',
            key: _d_rs._KEY || -1,
            idx: _idx,
            d_flds: _d_rs,
            dd_stgss: {},
            b_upd: false,
            b_new: false,
            b_dlt: false,
            b_hideCld: false, // hide child
            dld_cldDatsss: {},
//            dd_prtss: pd2.dd_prtss,
          };
        }) || [];
 
//bf.l('801: {}'.f(pd2.als)) 
        Promise.all(
          _ld_elmss
          .map( _d_elms => new Promise( async _o_end4 => { // ポインタが変更されないよう注意
//bf.l('805: {}'.f(pd2.als)) 
//            let _dd_prtss = bf.c(pd2.dd_prtss || {}, {[pd2.als]:_d_elms.d_flds}); // alias ごとに分ける
            let _dd_prtss = bf.c(pd2.dd_prtss || {}, {[pd2.als]:_d_elms}); // alias ごとに分ける
//            if (pd2.d_defs.op_act) await pd2.d_defs.op_act(_a_rs, pd2.dd_prtss)
//bf.l('805: {}'.f(pd2.als)) //　処理の進捗状況のトレースに便利
//if (pd2.als == 'mngAsr') bf.l('805: {}'.f(_d_elms)) 
//            if (pd2.d_defs.op_act) await pd2.d_defs.op_act(pd2.dd_prtss)
//bf.l('762: {}, {}'.f(pd2.als, _dd_prtss))
            if (pd2.d_defs.op_act) await pd2.d_defs.op_act(_dd_prtss)
//bf.l('764: {}'.f(pd2.als))
            if (bf.f(pd2.d_defs.dd_cldDefss) == true) {
//bf.l('809: {}'.f(pd2.als)) 
              Promise.all(
                Object.keys(pd2.d_defs.dd_cldDefss)
                .map( _cld => new Promise( _o_end5 => {
//bf.l('813: {}'.f(pd2.als)) 
                  let _d_defs = pd2.d_defs.dd_cldDefss[_cld];
                  _o_slc({
                    als: _cld,
                    dd_prtss: _dd_prtss,
                    d_defs: _d_defs,
                  })
                  .then( _a_rs2 => {
                    _d_elms.dld_cldDatsss[_cld] = _a_rs2;
//bf.l('822: {}'.f(pd2.als)) 
                    _o_end5();
                  });
                }))
              )
              .then(() => {
//bf.l('828: {}'.f(pd2.als)) 
                _o_end4();
              });
            }
            else {
//bf.l('833: {}'.f(pd2.als)) 
              _o_end4();
            };
          }))
        )
        .then(() => {
//bf.l('839: {}'.f(pd2.als)) 
          _o_end3(_ld_elmss);
        });
      }; 
    });
  });

  if (bf.i(pd.ctr, ['slc'])) {
    let _d_rs = {};
    Promise.all(
      Object.keys(pd.dd_elmDefss)
      .map( _als => new Promise( _o_end2 => {
        _o_slc({
          als: _als,
          dd_prtss: pd.dd_prtss || {},
          d_defs: pd.dd_elmDefss[_als],
        })
        .then( _a_rs => {
          _d_rs[_als] = _a_rs;
          _o_end2();
        });
      }))
    )
    .then(() => {
/*
      if ( bf.f(pd.state) == true ) {
        global.c?.setState({
          [pd.state]: _d_rs,
        }, () => {
          _o_end1(_d_rs);
        });
      }
      else {
        _o_end1(_d_rs);
      };
*/
/*
      new Promise( _o_end2 => {
        if (pd.o_atr) {
          _o_end2(pd.o_atr(_d_rs));
        }
        else{
          _o_end2(_d_rs);
        };
      })
      .then(() => {
        if ( bf.f(pd.state) == true ) {
          global.c?.setState({
            [pd.state]: _d_rs,
          }, () => {
            _o_end1(_d_rs);
          });
        }
        else {
          _o_end1(_d_rs);
        };
      });
*/
      new Promise( _o_end2 => {
        if ( bf.f(pd.state) == true ) {
          global.c?.setState({
            [pd.state]: _d_rs,
          }, () => {
            _o_end2();
          });
        }
        else {
          _o_end2();
        };
      })
      .then(() => {
        if (pd.op_atr) { // 事後処理
          pd.op_atr(_d_rs)
          .then(() => {
            _o_end1(_d_rs);
          });
        }
        else{
          _o_end1(_d_rs);
        };
      });
    });
  }

  const _o_iud = (pd2={
    als: '',
    d_elmDefs: {
      od_insDats: d_dats => {},
      o_updCnd: d_dats => {},
    },
    ld_datss: [
      {}
    ],
  }) => new Promise( _o_end2 => {
//bf.l('868: {}'.f(pd2.ld_datss))
    Promise.all(
//      .map( {_d_dats, _idx} => new Promise( _o_end4 => {
      pd2.ld_datss
      .map( (_d_dats, _idx) => new Promise( _o_end4 => {
//        _d_dats.idx = _idx;
        new Promise( _o_end3 => {
          // bf.l('899: {}, {}, {}, {}'.f(_d_dats.b_dlt, _d_dats.b_upd, _d_dats.b_new, _d_dats))
          if (_d_dats.b_dlt != true && _d_dats.b_upd == true && _d_dats.b_new == true) {
//bf.l('875: here')
            let _d = pd2.d_elmDefs.od_insDats(
              bf.c(pd2.dd_prtss, {[pd2.als]: _d_dats}),              
              _idx,
            );
//bf.l('898: {}'.f(_d))
            cf.myCB_call_iud({
              ctr: 'ins',
              elm: _d_dats.elm,
              d_vals: _d,
            })
            .then( _d_rs => {
              _o_end3(bf.c(_d_dats, {d_flds: _d_rs}));
            })
          }
          else if (_d_dats.b_dlt != true && _d_dats.b_upd == true && _d_dats.b_new == false) {
//bf.l('889: here')
            let _d = {};
            Object.keys(_d_dats.dd_stgss)
            .map( _fld => {
              if (_d_dats.dd_stgss[_fld].b_chg == true) {
                _d[_fld] = _d_dats.d_flds[_fld];
              }
            });
            let _cnd = (pd2.d_elmDefs.o_updCnd) ? 
              pd2.d_elmDefs.o_updCnd(
                bf.c(pd.dd_prtss, {[pd2.als]: _d_dats}),
              )
            : // 初期値
              bf.q(`
                [_KEY]={}
              `.f(
                _d_dats.d_flds._KEY
              ))
            ;            
            cf.myCB_call_iud({
              ctr: 'upd',
              elm: _d_dats.elm,
              d_vals: _d,
              cnd: _cnd,
            })
            .then( () => {
              _o_end3(_d_dats);
            })
          }
//          else if (_d_dats.b_dlt == true && _d_dats.b_new == false) {
//          else if (_d_dats.b_dlt == true && _d_dats.b_new != false) {
          else if (_d_dats.b_dlt == true && _d_dats.b_new != true) {
            let _d = {
              ['{}cz10'.f(_d_dats.elm)]: '0',
            };
            let _cnd = (pd2.d_elmDefs.o_updCnd) ? 
              pd2.d_elmDefs.o_updCnd(
                bf.c(pd.dd_prtss, {[pd2.als]: _d_dats}),
              )
            : // 初期値
              bf.q(`
                [_KEY]={}
              `.f(
                _d_dats.d_flds._KEY
              ))
            ;            
//bf.l('929: {}'.f(_cnd, _d))
            cf.myCB_call_iud({
              ctr: 'upd',
              elm: _d_dats.elm,
              d_vals: _d,
              cnd: _cnd,
            })
            .then( () => {
              _o_end3(_d_dats);
            })
          }
          else { // スルーの場合を考慮
//bf.l('908: here')
            _o_end3(_d_dats);
          }
        })
        .then( _d_dats2 => { // 子要素の処理
          if ( pd2.d_elmDefs.dd_cldDefss ) {
            let _dd_prtss = bf.c(pd2.dd_prtss, {[pd2.als]: _d_dats2})
            Promise.all(
              Object.keys(pd2.d_elmDefs.dd_cldDefss)
              .map( _als => new Promise( _o_end5 => {
                if (
                  _d_dats.dld_cldDatsss && 
                  _d_dats.dld_cldDatsss[_als]
                ) {
                  _o_iud({
                    als: _als,
                    d_elmDefs: pd2.d_elmDefs.dd_cldDefss[_als],
                    ld_datss: _d_dats.dld_cldDatsss[_als],
                    dd_prtss: _dd_prtss
                  })
                  .then(() => {
                    _o_end5();
                  });
                }
                else {
                  _o_end5();
                };
              }))
            )
            .then(() => {
              _o_end4();
            })
          }
          else {
            _o_end4();
          };
        }); 
      }))
    )
    .then(() => {
      _o_end2();
    });
  });

  if (bf.i(pd.ctr, ['iud'])) {
    Promise.all(
      Object.keys(pd.dd_elmDefss)
      .map( _als => new Promise( _o_end6 => {
        _o_iud({
          als: _als,
          d_elmDefs: pd.dd_elmDefss[_als],
          ld_datss: global.c?.state[pd.state][_als],
          dd_prtss: {},
        })
        .then(() => {
          _o_end6();
        });
      }))
    )
    .then(() => {
      _o_end1();
    });
  };

});

/*
static myCB_iud_tree = (pd={
  state: '',
  dd_elmDefss: {
    als: {
      od_insDats: d_dats => {},
      o_updCnd: d_dats => {},
      dd_cldDefss: {
      },
    },
  },
}) => new Promise( _o_end1 => {

  const _o_iud = (pd2={
    als: '',
    d_elmDefs: {
      od_insDats: d_dats => {},
      o_updCnd: d_dats => {},
    },
    ld_datss: [
      {}
    ],
  }) => new Promise( _o_end2 => {
    Promise.all(
      pd2.ld_datss
      .map( _d_dats => new Promise( _o_end4 => {

        new Promise( _o_end3 => {
          if (_d_dats.b_ins == true) {
            let _d = pd2.d_elmDefs.od_insDats(
              bf.c(pd2.dd_prtss, {[pd2.als]: _d_dats}),
            );
            cf.myCB_call_iud({
              ctr: 'ins',
              elm: _d_dats.elm,
              d_vals: _d,
            })
            .then( _d_rs => {
              _o_end3(bf.c(_d_dats, {d_flds: _d_rs}));
            })
          };
          if (_d_dats.b_upd == true) {
            let _d = {};
            Object.keys(_d_dats.dd_stgss)
            .map( _fld => {
              if (_d_dats.dd_stgss[_fld].b_chg == true) {
                _d[_fld] = _d_dats.d_flds[_fld];
              }
            });
            let _cnd = (pd2.d_elmDefs.o_updCnd) ? 
              pd2.d_elmDefs.o_updCnd(
                bf.c(pd.dd_prtss, {[pd2.als]: _d_dats}),
              )
            : // 初期値
              bf.q(`
                [_KEY]={}
              `.f(
                _d_dats.d_flds._KEY
              ))
            ;            
            cf.myCB_call_iud({
              ctr: 'upd',
              elm: _d_dats.elm,
              d_vals: _d,
              cnd: _cnd,
            })
            .then( () => {
              _o_end3(_d_dats);
            })
          };
        })
        .then( _d_dats2 => {
          if ( pd2.d_elmDefs.dd_cldDefss ) {
            let _dd_prtss = bf.c(pd2.dd_prtss, {[pd2.als]: _d_dats2})
            Promise.all(
              Object.keys(pd2.d_elmDefs.dd_cldDefss)
              .map( _als => new Promise( _o_end5 => {
                if (
                  _d_dats.dld_cldsss && 
                  _d_dats.dld_cldsss[_als]
                ) {
                  _o_iud({
                    als: _als,
                    d_elmDefs: pd2.d_elmDefs.dd_cldDefss[_als],
                    ld_datss: _d_dats.dld_cldsss[_als],
                    dd_prtss: _dd_prtss
                  })
                  .then(() => {
                    _o_end5();
                  });
                }
                else {
                  _o_end5();
                };
              }))
            )
            .then(() => {
              _o_end4();
            })
          }
          else {
            _o_end4();
          };
        }); 
      }))
    )
    .then(() => {
      _o_end2();
    });
  });

  Promise.all(
    Object.keys(pd.dd_elmDefss)
    .map( _als => {
      _o_iud({
        als: _als,
        d_elmDefs: pd.dd_elmDefss[_als],
        ld_datss: global.c?.state[pd.state][_als],
        dd_prtss: {},
      })
    })
  )
  .then(() => {
    _o_end1();
  });

});
*/

//  static myCB_set_clds = (p_state, pd) => new Promise( _o_end1 => {
  static myCB_set_clds = (pd={
  }) => new Promise( _o_end1 => {
    if (pd.b_withCnd == true && bf.f(pd.cnd) == false) { // pd.cnd が空白の場合は clds を取得しない
/*
      let _l = [];
      global.c?.setState({
        [pd.state]: _l,
      }, ()=>{
        _o_end1(_l);
      });
*/
      let _r = []; // list only
      global.c?.setState({
        [pd.state]: _r,
      }, ()=>{
        _o_end1(_r);
      });
    }
    else {
      cf.myCB_call_slc(pd)
      .then( async _ld_iss => { // list only
        global.c?.setState({
          [pd.state]: _ld_iss,
        }, ()=>{
          _o_end1(_ld_iss);
        });
      });
    };
  });

//  static myCB_set_items = (p_state, pd, po_fnc) => {
  static myCB_set_items = (pd={
    state: '',
    o_fnc: () => null,
  }) => {
    return new Promise( _o_end1 => {
      cf.myCB_call_slc(pd)
      .then( async _ld_itemss => {
        let _ld_valss = [];
        for await (let [_idx, _d_items] of bf.e(_ld_itemss)) {
          let _d_items2 = await pd.o_fnc(_d_items);
          _d_items2.key = _d_items._KEY;
          _d_items2.val = _d_items;
          _ld_valss.push(_d_items2);
        };
        global.c?.setState({
          [pd.state]: _ld_valss,
        }, ()=>{
          _o_end1(_ld_itemss);
        });
      })
    });
  }

  static myCB_call_rfr(pd_vals, p_elm, p_cnd='', pdd_cashss=null){ // 複数の elm/cnd に対応可能とする
    return new Promise((resolve) => {
      if (pdd_cashss && pdd_cashss[p_cnd]) { // キャッシュが指定されており、キャッシュが存在する場合
        resolve(bf.myCM_upd(pdd_cashss[p_cnd], pd_vals)) // pd_vals の _KEY を消さないよう上書き
      }
      else {
        let _ld_valss = [
          {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, mode:'slc', ctr:'nlm', prc:'', vwi:'', idc:'{}/'.f(p_elm), fld:'',
            dms:2, // 2 固定
            cnd:p_cnd,
          }},
        ];
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        })
        .then((_a_res) => {
          if (pdd_cashss){ // キャッシュが指定されている場合
            //
            pdd_cashss[p_cnd] = _a_res;
            resolve(bf.myCM_upd(pdd_cashss[p_cnd], pd_vals)) // pd_vals の _KEY を消さないよう上書き
          }
          else { // キャッシュが指定されてない場合
            resolve(bf.myCM_upd(_a_res, pd_vals)) // pd_vals の _KEY を消さないよう上書き
          }
        });
      }
    });
  };

/*
  static myCB_call_upl(p_elm, p_fld, p_key, pd_files){
    return new Promise((resolve, reject)=>{
      if (bf.f(pd_files.uri) && pd_files.lct == 'int') { // uri が 指定されており http画像以外の場合
        //
        let _ld_valss = [];
        //
        if (!cf.myRN_chk_os('w')) { // ios/android の場合
          _ld_valss = [
            {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, ctr:'upl', prc:'', vwi:'', idc:'{}/{}'.f(p_elm, p_key), fld:'',
              val:{mode:'open', flds:{file:p_fld}, type:'file'} // 単一のフィールドに変更する必要あり
            }},
            {key:'file', vals:{
              uri: pd_files.uri, name: pd_files.name, type: pd_files.type,
            }}
          ];
        }
        else{ // web の場合
          _ld_valss = [
            {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, ctr:'upl', prc:'', vwi:'', idc:'{}/{}'.f(p_elm, p_key), fld:'',
              val:{mode:'open', fld:p_fld, type:'base64', base64:pd_files.uric.split(',')[1], name:pd_files.name} 
            }},
          ];
        };
        //
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        })
        .then((_a_res) => {
            resolve(_a_res);
        })
        .catch((_err) =>{
            reject(_err);
        }); 
          
      }
      else {
        reject('incorrect file.');
      };
    });
  };
*/
  static myCB_call_upl = (pd={
    elm: '',
    fld: '',
    key: '',
    d_files: {},
  }) => {
    return new Promise((resolve, reject)=>{
      if (bf.f(pd.d_files.uri) && pd.d_files.lct == 'int') { // uri が 指定されており http画像以外の場合
        //
        let _ld_valss = [];
        //
        if (!cf.myRN_chk_os('w')) { // ios/android の場合
          _ld_valss = [
            {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, ctr:'upl', prc:'', vwi:'', idc:'{}/{}'.f(pd.elm, pd.key), fld:'',
              val:{mode:'open', flds:{file:pd.fld}, type:'file'} // 単一のフィールドに変更する必要あり
            }},
            {key:'file', vals:{
              uri: pd.d_files.uri, name: pd.d_files.name, type: pd.d_files.type,
            }}
          ];
        }
        else{ // web の場合
          _ld_valss = [
            {key:'data', vals:{ usr:global.c?.state.sgc_user_key, tkn:global.c?.state.sgc_tkn, ctr:'upl', prc:'', vwi:'', idc:'{}/{}'.f(pd.elm, pd.key), fld:'',
//              val:{mode:'open', fld:pd.fld, type:'base64', base64:pd.d_files.uric.split(',')[1], name:pd.d_files.name} 
              val:{mode:'open', fld:pd.fld, type:'base64', base64:pd.d_files.uri.split(',')[1], name:pd.d_files.name} 
            }},
          ];
        };
        //
//bf.l('1299: {}'.f(ic.g_url1))
//bf.l('1299: {}'.f(_ld_valss))
        cf.myCR_xhr({
          mode: 'POST',
          url: ic.g_url1, 
          ld_valss: _ld_valss
        })
        .then((_a_res) => {
//bf.l('1305: {}'.f(_a_res))
            resolve(_a_res);
        })
        .catch((_err) =>{
//bf.l('1309: {}'.f(_err))
            reject(_err);
        }); 
          
      }
      else {
        reject('incorrect file.');
      };
    });
  };

/*
//  static myCB_call_uplCt10 = (pd={
  static myCB_call_ct10 = (pd={
    ctr: '', // upl, slc
    elm: '', // upl, slc 
    key: '', // upl, slc
    d_files: {}, // upl
    state: '', // slc
  }) => {
    return new Promise( _o_end1 => {
      if (pd.ctr == 'upl') {
        let _d = {
          ct10l11e: pd.elm,
          ct10l11k: pd.key,
          ct10c110: '',
          ct10c310: pd.d_files.name,
          ct10c610: '',
          ct10cy10: bf.myDT_get_now(),
          ct10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key,
          ct10cz10: '10',
        };
        cf.myCB_call_iud({
          ctr: 'ins', 
          elm: 'ct10', 
          d_vals: _d,
        })
        .then( _d_ct10s => {
          cf.myCB_call_upl({
            elm: 'ct10', 
            fld: 'ct10c610', 
            key: _d_ct10s._KEY, 
            d_files: pd.d_files
          })
          .then( () => {
            _o_end1();
          });
        });
      };
      if (pd.ctr == 'slc') {
        let _cnd = bf.q(`[ct10l11e]="{}" AND [ct10l11k]="{}" AND IFNULL([ct10cz10],"10")="10"`.f(
          pd.elm,
          pd.key
        )); // 削除済でないファイル
//bf.l('693:{}'.f(_cnd))
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'ct10', 
          n_dms: 3, 
          cnd: _cnd,
        })
        .then(async (_ld_ct10ss) => {
//bf.l('700:{}'.f(_ld_ct10ss))
          let _ld_filess = _ld_ct10ss
          .filter( _d_ct10s => {
//bf.l('702:{}'.f(_d_ct10s))
            return ( _d_ct10s.ct10c610 != '') ? true : false;
          })
          .map( _d_ct10s => {
            let _d_ct10c610s = bf.j(_d_ct10s.ct10c610);
            let _d = {
                _KEY: _d_ct10s._KEY,
                lct: 'ext',
                name: _d_ct10c610s.name,
                url: '{}/{}'.f(ic.g_url2, _d_ct10c610s.file),
            };
            return _d;
          });
//bf.l('714:{}'.f(_ld_filess))
          global.c?.setState({
            [pd.state]: _ld_filess,
          }, () => {
//            _o_end1(_ld_filess);
//bf.l('719:{}'.f(global.c?.state[pd.state]))
            _o_end1();
          });
        });
      };
    })
  };
*/

/*
  static myCB_call_slcCt10 = (pd={
    elm: '',
    key: '',
  }) => {
    new Promise( _o_end1 => {
    });
  };
*/

  static myCB_call_ver(){
    return new Promise((resolve, reject)=>{
      //
      if (!bf.f(ic.g_url1)){
        resolve(null);
      };
      //
      let _ld_valss = [
        {key:'data', vals:{ usr:'-1', tkn:'', ctr:'ver', prc:'', vwi:'', idc:'/', fld:'',
        }},
      ];
      cf.myCR_xhr({
        mode: 'POST',
        url: ic.g_url1, 
        ld_valss: _ld_valss
      })
      .then((_a_res) => {
        resolve(_a_res);
      })
      .catch((_err) => {
        reject(_err);
      });
    });
  };

  static myCB_load_tree = (pd={
    state: '',
    d_pntItems: {}, // defined only at root
    elm: '',
    o_cnd: _d_items => {},
    do_rfrs: {},
    l_flds: [''],
    ld_sortss: [],
    d_cldDefs: { // same with pd
      elm: '',
      cnd: _d_items => {},
      do_rfrs: {},
      l_flds: [],
      d_cldDefs: {},
    },
    b_newLine: false, // with new line
    b_mplLine: false, // multiple line
  }) => new Promise( async _o_end1 => {

    let _cnd = pd.o_cnd(pd.d_pntItems) || '';
//    _cnd = ((bf.f(_cnd)) ? '({}) AND '.f(_cnd) : '') + bf.q('IFNULL([{}cz10],"10")<>"0"'.f(pd.elm)); // 非表示は対象外
//    _cnd = ((bf.f(_cnd)) ? '({}) AND '.f(_cnd) : '') + bf.q('IFNULL([{}cz10],"10")<>"0"'.f(pd.elm)); // 非表示は対象外

    await cf.myCB_call_slc({
      ctr: 'nlm', 
      elm: pd.elm, 
      n_dms: 3, 
      cnd: _cnd,
      do_rfrs: pd.do_rfrs,
      ld_sortss: pd.ld_sortss,
    })
    .then( async _ld_itemss => {

//bf.l('802: {}, {}'.f(_cnd, _ld_itemss));
      if (pd.b_newLine == true) { // 空白行ありの場合
        if (
          pd.b_mplLine == true || // 複数行の場合
          (pd.b_mplLine != true && !bf.f(_ld_itemss)) // 単数行で値がない場合
        ) {
          _ld_itemss = bf.c(_ld_itemss, [{
            _KEY: 'new',
          }]);
        };
      }

//bf.l('810:{}'.f(_ld_itemss));
      let _ld_treeItemss = await Promise.all(_ld_itemss.map( async _d_items => { // map で async を使用する場合、await Promise.all で括る
        //
        let _ld_fldss = pd.ld_fldss.map( _d_flds => {
          return bf.c(_d_flds, { // phd を指定したい場合は、呼び出し元の ld_fldss を設定
            ini: _d_items[_d_flds.fld],
            val: _d_items[_d_flds.fld],
            b_uid: false,
          });
        });
        //
        let _ld_cldElmss = [];
        if (bf.f(pd.d_cldDefs)) {
          await cf.myCB_load_tree(bf.p(pd.d_cldDefs, _next => {
            _next.d_pntItems = _d_items;
          }))
          .then( _res => {
            if(bf.f(_res)) {
              _ld_cldElmss = _res;
            }
          });
        };            
        //
        return { // _d_treeItems
          elm: pd.elm,
          key: _d_items._KEY,
          b_dlt: false,
          b_cls: false,
          ld_fldss: _ld_fldss,
          ld_cldElmss: _ld_cldElmss,
          d_is: _d_items, // 各fldにおいて d_is を参照するために必要
         };
      }));

//bf.l('843:{}'.f(_ld_treeItemss));
      if (bf.f(pd.state)) {
        global.c?.setState({
          [pd.state]: _ld_treeItemss,
        }, () => {
          _o_end1(_ld_treeItemss);
        });
      }
      else {
        _o_end1(_ld_treeItemss);
      };    
    });
  });

  static myCB_ups_tree = (pd={
    elm: '', // only for identification
    pntKey: '',
    ld_elmss: [],
    o_insFlds: (_d_elms, _pntKey) => {},
    do_updFlds: {'fldName': (_d_elms, _pntKey) => {}},
    d_cldDefs: {}, // same with pd
  }) => new Promise( async _o_end1 => {
    let _pntKey = pd.pntKey || '';
//if (pd.elm == 'ct30') bf.l('1468:{}'.f(pd.ld_elmss));
    await pd.ld_elmss?.map( _d_elms => {
//if (pd.elm == 'ct30') bf.l('1470:{}'.f(_d_elms));
      if (_d_elms.b_dlt == true) { // 削除データの場合
//if (pd.elm == 'ct30') bf.l('1472:here');
        if ('{}'.f(_d_elms.key).substr(0,3) == 'new') { // 新規データの場合
//bf.l('873:here');
          //// 対応事項なし
        }
        else { // 既存データの場合
//if (pd.elm == 'ct30') bf.l('1478:here');
          let _d = {
            ['{}cz10'.f(_d_elms.elm)] : '0', // 非表示
          };
          let _cnd = bf.q(`[_KEY]={}`.f(_d_elms.key));
//bf.l('882:{}, {}'.f(_cnd, _d))
          cf.myCB_call_iud({
            ctr: 'upd', 
            elm:_d_elms.elm, 
            d_vals: _d, 
            cnd: _cnd
          })
          .then(() => {
//bf.l('890:here');
          });
        };
      }
      else { // 削除データではない場合
        new Promise ( async _o_end3 => {
//if (pd.elm == 'ct30') bf.l('1497:{}'.f(_d_elms));
          if ('{}'.f(_d_elms.key).substr(0,3) == 'new') { // 新規データの場合
//if (pd.elm == 'ct30') bf.l('1499:here');
            let _d = pd.o_insFlds(_d_elms, _pntKey);
//bf.l('900:{}'.f(_d));
            cf.myCB_call_iud({
              ctr: 'ins', 
              elm: _d_elms.elm, 
              d_vals: _d
            })
            .then( _res => {
//bf.l('907:{}'.f(_res));
                _o_end3(_res._KEY);
            })
          }
          else { // 既存データの場合
//if (pd.elm == 'ct30') bf.l('1513:here');
            if (bf.f(pd.do_updFlds)) {
//bf.l('914:here');
              let _cnd = bf.q(`[_KEY]={}`.f(_d_elms.key));
//if (pd.elm == 'ct30') bf.l('1517: {}'.f(_cnd));
//bf.l('916:{}'.f(_cnd));
              await _d_elms.ld_fldss.map( _d_flds => { // fld ごとにデータを更新
//if (pd.elm == 'ct30') bf.l('1520: {}, {}'.f(_d_flds.b_uid, _d_flds));
//bf.l('918:here');
                if (_d_flds.b_uid == true) {
                  let _d = {
                    [_d_flds.fld]: pd.do_updFlds[_d_flds.fld](_d_elms, _pntKey)
                  };
//alert('776:{}'.f(_d));
//bf.l('924:{}, {}'.f(_d));
                  if (bf.f(_d)) {
                    cf.myCB_call_iud({
                      ctr: 'upd', 
                      elm: _d_elms.elm, 
                      d_vals: _d, 
                      cnd: _cnd
                    });
                  };
                };
              });
            };
            _o_end3(_d_elms.key);
          };
        })
        .then( async _crrKey => {
//bf.l('940:{}'.f(_crrKey));
          if (bf.f(_d_elms.ld_cldElmss)) { // 子要素が存在する場合
            cf.myCB_ups_tree(bf.p(pd.d_cldDefs, _next => {
              _next.pntKey = _crrKey;
              _next.ld_elmss = _d_elms.ld_cldElmss;
            }));
          };
        });
      };
    });
    _o_end1();
  });

  static myCB_hlr = (pd={ // handler
    elm: '',
    mode: 'get/set/itemss/clds/ins/upd/ups',
    d_vals: {}, // ins/upd/ups
    cnd: '',
    b_clr: false, // get/set
    state: '', // items/clds
    od_setDefs: (pd_is) => {}, // set
    od_itemsDefs: (pd_is) => {}, // items
    od_upsDefs: () => {},
    b_wotDlt: false, // items
    do_rfrs: {
      fld: _d_items => o_cnd(_d_items),
    }, // items
    dld_pcksss: {
      fld: [
        {key:'', pfx:''},
      ],
    }, // items
    ld_sortss: [
      {fld:'_KEY', dtn:'asc'}
    ], // items
  }) => new Promise( _o_end1 => {

    if (pd.mode == 'get') {
      if (pd.b_clr == true) {
        _o_end1(null);
      }
      else {
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: pd.elm, 
          n_dms: 2, 
          cnd: pd.cnd
        })
        .then( _d_ress => {
          _o_end1(_d_ress);
        });
      };
    }
    else if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: pd.elm, 
            n_dms: 2, 
            cnd: pd.cnd
          })
          .then( _d_rs => {
            _o_end2(_d_rs);
          });
        };
      })
      .then( _d_rs => {
        _d_rs = bf.f(_d_rs) ? _d_rs : {};
        global.c?.setState(
          pd.od_setDefs(_d_rs), 
          () => {
            _o_end1(_d_rs);
          }
        );
      })
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: pd.elm, 
        n_dms: 3,
        state: pd.state, 
        cnd: pd.cnd,
        do_rfrs: pd.do_rfrs,
        dld_pcksss: pd.dld_pcksss,
        ld_sortss: pd.ld_sortss,
        o_fnc: _d_items => {
          let _d_rss = pd.od_itemsDefs(_d_items);
          _d_rss.b_dlt = (pd.b_wotDlt == true && _d_items['{}cz10'.f(pd.elm)] == '0') ? true : false; // b_wotDlt == true かつ cz10 == '0' は 表示対象外
          return _d_rss;
        },
      })
      .then( _ld_rss => {
        _o_end1(_ld_rss)
      });
    }
/*
    else if (pd.mode == 'cld') {
      cf.myCB_set_clds(
        {
          ctr: 'nlm', 
          elm: pd.elm, 
          n_dms: 2, 
          cnd: pd.cnd || '',
          state: pd.state,
          b_withCnd: pd.b_withCnd || false, // false の場合 cnd == '' では値が検索されない
          do_rfrs: pd.do_rfrs,
          dld_pcksss: null, // pd.dld_pcksss は反映しない 区分値が置き換わるため
          ld_sortss: pd.ld_sortss,
        }
      )
      .then( _d_is => {
        _o_end1(_d_is);
      });
    }
*/
    else if (pd.mode == 'clds') {
      cf.myCB_set_clds(
        {
          ctr: 'nlm', 
          elm: pd.elm, 
          n_dms: 3, 
          cnd: pd.cnd || '',
          state: pd.state,
          b_withCnd: pd.b_withCnd || false, // false の場合 cnd == '' では値が検索されない
          do_rfrs: pd.do_rfrs,
          dld_pcksss: null, // pd.dld_pcksss は反映しない 区分値が置き換わるため
          ld_sortss: pd.ld_sortss,
        }
      )
      .then( (_ld_iss) => {
        _o_end1(_ld_iss);
      });
    }
    else if (pd.mode == 'file') {
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: pd.elm, 
        n_dms: 3, 
        cnd: pd.cnd,
        b_withCnd: true, // false の場合 cnd == '' では値が検索されない
        do_rfrs: pd.do_rfrs,
        dld_pcksss: pd.dld_pcksss,
        ld_sortss: pd.ld_sortss,
      })
      .then( _ld_iss => {
        let _ld = bf.c(
          [pd.od_fileDefs().hdr],
          _ld_iss.map( _d_is => {
            return pd.od_fileDefs(_d_is).val
          })
        );
        let _s = _ld.join('\n');
        _o_end1(_s);
      });
    }
    else if (pd.mode == 'ins') {

      new Promise( _o_end2 => {
        if (pd.o_cndCw10) {
          cf.myCB_call_slc({
            ctr: 'nlm',
            elm: pd.elm,
            n_dms: 2,
            cnd: pd.o_cndCw10(),
          })
          .then( _d_elms => {
            if (bf.f(_d_elms) == false) {
              _o_end2(true);
            }
            else {
              _o_end2(false);
            };
          });
        }
        else {
          _o_end2(true);
        };
      })
      .then( _b_noDct => { // no duplicate
        if (_b_noDct) {
          let _d_vals = (pd.d_vals) ? pd.d_vals : pd.od_insDefs();
          cf.myCB_call_iud({
            ctr: 'ins', 
            elm: pd.elm,
            d_vals: _d_vals, // 個別データが指定されている場合、個別データを優先（ファイルアップロードを考慮？）
          })
          .then( _d_rs => {
            _o_end1(_d_rs);
          });
        }
        else {
          alert('IDが重複しているため保存できませんでした');
          _o_end1(null);
        };
      })
    }
    else if (pd.mode == 'upd') {
      new Promise( _o_end2 => {
        if (pd.o_cndCw10) {
          cf.myCB_call_slc({
            ctr: 'nlm',
            elm: pd.elm,
            n_dms: 2,
            cnd: pd.o_cndCw10(),
          })
          .then( _d_elms => {
            if (bf.f(_d_elms) == false) {
              _o_end2(true);
            }
            else {
              _o_end2(false);
            };
          });
        }
        else {
          _o_end2(true);
        };
      })
      .then( _b_noDct => { // no duplicate
        if (_b_noDct) {
          if (bf.f(pd.cnd)) {
            cf.myCB_call_iud({
              ctr: 'upd', 
              elm: pd.elm, 
              d_vals: (pd.d_vals) ? pd.d_vals : pd.od_updDefs(), // 個別データが指定されている場合、個別データを優先（ファイルアップロードを考慮？）
              cnd: pd.cnd
            })
            .then( () => {
              _o_end1(true);
            });
          }
          else {
            alert('891:incorrect cnd at myCB_hlr: {}, {}, {}'.f(pd.elm, pd.mode, pd.cnd));
          };
        }
        else {
          alert('IDが重複しているため保存できませんでした');
          _o_end1(false);
        };
      })
    }
    else if (pd.mode == 'ups') {
      if (bf.f(pd.cnd)) {
        cf.myCB_call_iud({
          ctr: 'ups', 
          elm: pd.elm, 
          d_vals: (pd.d_vals) ? pd.d_vals : pd.od_upsDefs(), 
          cnd: pd.cnd
        })
        .then( _n_key => {
          _o_end1(_n_key);
        });
/*
        .then( () => {
          _o_end1();
        });
*/
      }
      else {
        alert('901:incorrect cnd at myCB_hlr: {}, {}'.f(pd.elm, pd.cnd));
      };
    }
    else if (pd.mode == 'iudClds') {
//bf.l('1152:here');
      global.c?.state[pd.state].map( _d_is => { 
        let _d = pd.od_iudCldsDefs( _d_is );
//bf.l('1155:{}'.f(_d_is));
        if (bf.f(_d.d_vals) && bf.f(_d.cnd)) {
          cf.myCB_call_iud({
            ctr: 'ups', 
            elm: pd.elm, 
            d_vals: _d.d_vals, 
            cnd: _d.cnd,
          })
          .then(() => {
            if (_d.o_atr) {
              _d.o_atr();
            }
          });
        };
      });
      _o_end1();
    }
    else {
      alert('905:incorrect mode at myCB_hlr: {}'.f(pd.mode));
    };

  });

  ////////////////////////////////////////////////////////////////////////
static myCL_set = p_text => new Promise( async _o_end1 => {
  await Clipboard.setString(p_text);
  _o_end1();
});

/*
static myCL_get = () => new Promise( async _o_end1 => {
//  let _text = await CL.setStringAsync() ?? null;
  let _text = await Clipboard.setString() ?? null;
  _o_end1(_text);
});
*/

  ////////////////////////////////////////////////////////////////////////
  static myCR_post(p_url, pd_vals, po_fnc) {
    return fetch(p_url, {
      method: "POST", 
      body: bf.myCM_cnv('json-str', pd_vals)
    })
    .then((_res) => _res.json())
    .then((_d_ress) => po_fnc(_d_ress));
  };

  static myCR_sbm(p_url, pld_valss, po_fnc=null) { // pld_valss = [{key:'file', vals:{'uri':'', 'name':'', 'type':'image/jpg'}}], p_name : input element name // ファイルは１回に１つしか送れない？
    //
    let _o_this = this;
    //
    let _body = new FormData();
    //
    this.myCM_for_each(pld_valss, function (_d_vals) {
      if (_d_vals['key'] == 'data') {
        _body.append(_d_vals['key'], JSON.stringify(_d_vals['vals']));
      }
      else {
        _body.append(_d_vals['key'], _d_vals['vals']);
      };
    });

    if (po_fnc != null) {
      return fetch(p_url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data',
        },
        body: _body
      })
      .then((_res) => { 
        if (_res != null) {
          return _res.json();
        }
        else {
          return 'null';
        }
      })
      .then((_d_res) => {
        po_fnc(_d_res);
      })
      .catch((_err)=>{
        //alert('{} : {}'.f(_err.message, JSON.stringify(_body)));
      });
    }
    else {
      return fetch(p_url, {
        method: 'POST',
        headers: {
          "Content-Type": "multipart/form-data",
        },
        body: _body
      })
      .catch((_err)=>{
      });
    };
  };

  static myCR_xhr(pd={
    mode:'POST',
    url:'', 
    ld_valss:[], 
  }) { // pld_valss = [{key:'file', vals:{'uri':'', 'name':'', 'type':'image/jpg'}}], p_name : input element name // ファイルは１回に１つしか送れない？
    return new Promise(async (_o_end1, _o_err1) => {

      let _body = new FormData();

      if (pd.ld_valss) {
        for await (let [_idx, _d_vals] of bf.e(pd.ld_valss)) {
          if (_d_vals.key == 'data') {
            _body.append('data', bf.s(_d_vals.vals));
          };
          if (_d_vals.key == 'file') { // 1bodyに含められるfileは1つのみ
            _body.append('file', _d_vals.vals);
          };
        };
      };

      fetch(pd.url, { // mobile device と api server が同一のネットワークにないと ファイルアップロードを正しく行えない場合がある模様
        method: pd.mode,
        body: _body,
      })
      .then( _res => {
        _o_end1( _res.json() );
      })
      .catch( _err => {
        _o_err1(_err);
      });
    });
  };

/*
  static myCR_xhr(pd={
    mode:'POST',
    url:'', 
    ld_valss:[], 
  }) { // pld_valss = [{key:'file', vals:{'uri':'', 'name':'', 'type':'image/jpg'}}], p_name : input element name // ファイルは１回に１つしか送れない？
    return new Promise(async (_o_end1, _o_err1) => {

      let _body = new FormData();

      if (pd.ld_valss) {
        for await (let [_idx, _d_vals] of bf.e(pd.ld_valss)) {
          if (_d_vals.key == 'data') {
            _body.append('data', bf.s(_d_vals.vals));
          };
          if (_d_vals.key == 'file') { // 1bodyに含められるfileは1つのみ
            _body.append('file', _d_vals.vals);
          };
        };
      };

//bf.l('2038: {}'.f(_body))
      let _xhr = new XMLHttpRequest();
      _xhr.open(pd.mode, pd.url, true);
      _xhr.responseType = 'json';
      _xhr.send(_body);
      _xhr.onreadystatechange = () => {
        if( _xhr.readyState === 4 && _xhr.status === 200 ) { // _xhr.status が 0 の場合は、nginx の conf.d を確認
          _o_end1(_xhr.response);
        }
      };
      _xhr.onerror = () => {
        _o_err1(_xhr.statusText);
      };
    });
  };
*/

  //////////////////////////////////////////////////////////////////////// for local storage

  static myLS_chk() { // asyncstorage ( = cookie を利用可能かの確認 )
    return new Promise( _o_end1 => {
      const _key = 'CheckAsyncStorage';
      const _val = 'Enabled'
      cf.myLS_set(_key, _val)
      .then( _b_res => {
        if ( _b_res == true ) {
          cf.myLS_get(_key)
          .then(_res => {
            if ( _res == _val ) {
              cf.myLS_rmv(_key)
              .then(() => {
                _o_end1(true);
              });
            }
            else {
              _o_end1(false);
            }
          });
        }
        else {
          _o_end1(false);
        };
      });
    });
  };

  static myLS_clr() { // clear : remove all items.
    return new Promise( _o_end1 => {
      AsyncStorage.clear(()=>{
        _o_end1();
      });
    });
  }    

/*
  static myLS_rmv(p_key) { // remove
    return new Promise( _o_end1 => {
      if (ic.gb_dbg) { // 開発
        AsyncStorage.removeItem(p_key)
        .then( () => {
          _o_end1();
        });
      }
      else { // 本番
        AsyncStorage.removeItem(bf.myCM_hash(p_key))
        .then( () => {
          _o_end1();
        });
      };
    });
  }    
*/
  static myLS_rmv(p_key) { // remove
    return new Promise( _o_end1 => {
      if (ic.gb_dbg) { // 開発
        AsyncStorage.removeItem(p_key)
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      }
      else { // 本番
        AsyncStorage.removeItem(bf.myCM_hash(p_key))
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      };
    });
  }    

/*
  static myLS_get(p_key, pb_cpt=true) { // 値が存在しない場合は null、promise を用いた並列化を検討要
    return new Promise( _o_end1 => {
      if (ic.gb_dbg || pb_cpt == false) { // 開発
        AsyncStorage.getItem(p_key)
        .then( _j => {
          _j = bf.j(_j);
          _o_end1(_j);
        });
      }
      else { // 本番
        AsyncStorage.getItem(bf.myCM_hash(p_key))
        .then( async _j => {
          _j = await bf.myCM_cpt('d', _j, ic.g_srt_key);
          _j = bf.j(_j);
          _o_end1(_j);
        });
      };
    })
  };
*/

static myLS_get(p_key, pb_cpt=true) { // 値が存在しない場合は null、promise を用いた並列化を検討要
  return new Promise( _o_end1 => {
    if (ic.gb_dbg || pb_cpt == false) { // 開発
      AsyncStorage.getItem(p_key)
      .then( _j => {
        _j = bf.j(_j);
        _o_end1(_j);
      })
      .catch( _err => {
        _o_end1(null);
      });
    }
    else { // 本番
      AsyncStorage.getItem(bf.myCM_hash(p_key))
      .then( async _j => {
        _j = await bf.myCM_cpt('d', _j, ic.g_srt_key);
        _j = bf.j(_j);
        _o_end1(_j);
      })
      .catch( _err => {
        _o_end1(null);
      });
    };
  })
};

static myLS_loadStt = (pd_stts) => new Promise( _o_end1 => {
  if (pd_stts) {
    let _d = {};
    Object.keys(pd_stts).map( _stt => {
      cf.myLS_get(_stt)
      .then( _d_ress => {
        _d[_stt] = (_d_ress != undefined) ? _d_ress : pd_stts[_stt];
      })
    })
    cf.myRN_setStt(_d, () => {
      _o_end1();
    });
  }
  else {
    _o_end1();
  };
});

/*
  static myLS_set(p_key, pa_val, pb_cpt=true) {
    return new Promise( _o_end1 => {
      if (ic.gb_dbg || pb_cpt == false) { // 開発
        AsyncStorage.setItem(
          p_key, 
          bf.s(pa_val)
        )
        .then( () => {
          _o_end1();
        });
      }
      else { // 本番
        AsyncStorage.setItem(
          bf.myCM_hash(p_key), 
          bf.myCM_cpt('e', bf.s(pa_val), ic.g_srt_key)
        )
        .then( () => {
          _o_end1();
        });
      };
    });
  };
*/

static myLS_saveStt = (
  pd_stts
) => new Promise( _o_end1 => {
  if (global.t?.state.sb_saveStt ?? false) { // 実行中の場合
    cf.myCM_wait(0.01)
    .then(() => {
      cf.myLS_saveStt(pd_stts)
      .then(() => {
        _o_end1();
      });
    });
  }
  else {
    global.t?.setState({
      sb_saveStt: true,
    }, () => {
      let _d = {};
      if (pd_stts) {
        Object.keys(pd_stts).map( _stt => {
          if (pd_stts != undefined && pd_stts[_stt] != undefined) {
            cf.myLS_set(_stt, pd_stts[_stt])
            .then( () => {
              _d[_stt] = pd_stts[_stt];
            });
          }
        });
      };
      cf.myRN_setStt(_d, () => {
        global.t?.setState({
          sb_saveStt: false,
        }, () => {
          _o_end1();
        });
      });
    });
  };
});    

  static myLS_set(p_key, pa_val, pb_cpt=true) {
    return new Promise( _o_end1 => {
      if (ic.gb_dbg || pb_cpt == false) { // 開発
        AsyncStorage.setItem(
          p_key, 
          bf.s(pa_val)
        )
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      }
      else { // 本番
        AsyncStorage.setItem(
          bf.myCM_hash(p_key), 
          bf.myCM_cpt('e', bf.s(pa_val), ic.g_srt_key)
        )
        .then( () => {
          _o_end1(true);
        })
        .catch( _err => {
          _o_end1(false);
        });
      };
    });
  };

    //////////////////////////////////////////////////////////////////////// for file-system

  static myFS_get_rootFdr() {
    return FileSystem.documentDirectory + 'Download/';
//    return FileSystem.documentDirectory;
  };                                    

  static myFS_make_fdr(p_fdr) { // make folder
    return new Promise((resolve)=>{
      FileSystem.readDirectoryAsync(p_fdr)
      .then(() => {
//bf.l('2248: {}'.f(p_fdr))
        resolve();
      })
      .catch((_err)=>{ // フォルダが存在しなかった場合
        FileSystem.makeDirectoryAsync(p_fdr)
        .then(() => {
//bf.l('2254: {}, {}'.f(p_fdr, _err))
          resolve();
        });
      })
    });
  };

  static async myFS_open_url(p_url, p_name){ // not support web
    if (cf.myRN_chk_os('i')) {
      FileSystem.downloadAsync(p_url, p_name)
      .then((_d_ress) => { // 
        Sharing.shareAsync(p_name)
      });
    };
    if (cf.myRN_chk_os('a')) {
      FileSystem.downloadAsync(p_url, p_name)
      .then( async _d_ress => { // 
        const _d_pmns = await MediaLibrary.requestPermissionsAsync();
        if (_d_pmns.status === "granted") {
          const _ast = await MediaLibrary.createAssetAsync(p_name);
          const _abm = await MediaLibrary.getAlbumAsync('Download');
          if (_abm === null) {
            await MediaLibrary.createAlbumAsync('Download', _ast, false);
          } else {
            await MediaLibrary.addAssetsToAlbumAsync([_ast], 'Download', false);
          };
          alert('ファイルをDownloadフォルダにダウンロードしました')
        };
      });
    };
  };

  static myFS_pck_file() { // file picker
    return new Promise( _o_end1 => {
      DocumentPicker.getDocumentAsync({
        multiple: true, // only for web
        copyToCacheDirectory: true, // google drive のファイルを upload する際に必要？
      })
      .then(async (_d_files)=>{
        if (_d_files.type == 'success') {
          _d_files.lct = 'int';
          _o_end1(_d_files); // android の場合 myCR_xhr で理由不明のエラー 同一ネットワークにないため？
        }
        else {
          _o_end1(null);
        };
      });
    });
  };

  //////////////////////////////////////////////////////////////////////// for image-picker

  static async myIP_chk_pms(p_msg) {
    if (Constants.platform.ios) {
      const { status } = await ImagePicker.requestCameraRollPermissionsAsync(Permissions.CAMERA_ROLL); // 変数名 status を変更してはいけないもよう
      if ( status !== 'granted') {
        Alert.alert(p_msg);
      }
    }
  };

  static async myIP_pick_img(po_fnc, p_type) {
    //
    if (p_type == 'all') {
      let _d_ress = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.All,
        allowsEditing: false,
        quality: 1,
      });
      if (!_d_ress.cancelled) { // uri:_res.uri
        po_fnc(_d_ress);
      };
    }
    else if (p_type == 'image') {
      let _d_ress = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: false,
        quality: 1,
      });
      if (!_d_ress.cancelled) { // uri:_res.uri
        po_fnc(_d_ress);
      };
    }
    else if (p_type == 'video') {
      let _d_ress = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Videos,
        allowsEditing: false,
        quality: 1,
      });
      if (!_d_ress.cancelled) { // uri:_res.uri
        po_fnc(_d_ress);
      };
    };
  };

  //////////////////////////////////////////////////////////////////////// for react-navigation
  static myNV_stt_move(pd={ // React Native Web において、画面の再描画・後戻り時に引数を正しく引用できないため、myLS は使用しない
    sgc_pageName: '',
  }) { // 子に渡す変数を pd_vals に指定
    //
    if (pd.sgc_pageName != cf.myNV_get_name()) { // 異なる画面の場合のみ遷移
      //
      let _o_this = global.c;
      //
      global.c = null; // 遷移後の画面において、componentDidMount 前に、古い po_this が参照されることを防ぐ
      //
      _o_this.props.navigation.navigate(
        pd.sgc_pageName, 
        {
          prms: cf.myNV_cpt_prms(pd)
        },
      ); // React Native Web において、画面の再描画・後戻り時に引数を正しく引用できないため、myLS は使用しない
    };
  };

  static myNV_end_move( po_this ) { // 親からのpd_vals を返す
    return new Promise( _o_end1 => { // web で再描画することを考慮し _tmp を myLS_rmv しない
//      let _srt = 'Ta0b1ibk2afgFTa0b1ibk2afgF';
//      _o_end1(bf.myCM_cpt('d', global.c?.props.route.params['prms'], _srt));
//alert('975:here');
      let _r = cf.myNV_get_prms( po_this );
//alert('977:here');
      _o_end1(_r);
//      _o_end1(cf.myNV_cnv_prms('d'));
    });
  };

/*    
  static myNV_get_vals(p_key=null) {
    return new Promise( _o_end1 => {
      if (bf.f(p_key)) {
        if (bf.f(global.c?.props.route.params)) {
          _o_end1(global.c?.props.route.params[p_key]);
        }
        else {
          _o_end1(null);
        };
      }
      else {
        _o_end1(global.c?.props.route.params);
      };
    });
  };
*/

  static myNV_cpt_prms = (pd) =>  {
    let _srt = 'joizaFFG{}fGAfgFGve3{}'.f(ic.g_app_name, ic.g_app_name); // app ごとに異なる srt とする
    let _r = bf.s(pd);
    _r = bf.myCM_cpt('e', _r, _srt);
    _r = bf.myCM_cnv('ecdBase64', _r); // base64 に変換しないと通らない
/*
*/
    return _r
  };

  static myNV_get_prms( po_this ) {
    let _srt = 'joizaFFG{}fGAfgFGve3{}'.f(ic.g_app_name, ic.g_app_name); // app ごとに異なる srt とする
    let _r = po_this.props.route.params['prms'];
    _r = bf.myCM_cnv('dcdBase64', _r); // base64 に変換しないと通らない
    _r = bf.myCM_cpt('d', _r, _srt);
/*
alert('1343:{}'.f(_r));
alert('1345:{}'.f(_r));
*/
    _r = bf.j(_r);
    return _r;
  };

/*
  static myNV_cnv_prms = (p_mode='e/d', pd={}) =>  {
    let _srt = 'Ta0b1ibk2afgFTa0b1ibk2afgF'; // same key word with myNV_get_prms
    if (p_mode == 'e') {
      return {prms: bf.myCM_cpt('e', pd, _srt)};
    };
    if (p_mode == 'd') {
      return bf.myCM_cpt('d', global.c?.props.route.params['prms'], _srt);
    };
  };
*/

  static myNV_get_name() { // get current screen name
    if (bf.f(global.c?.props.route.name)) {
      return global.c?.props.route.name;
    }
    else {
      return null;
    }
  };

  //////////////////////////////////////////////////////////////////////// for react native
  static myRN_crt_stss(pd_vals1, pd_vals2=null) {
/*
    if (bf.f(pd_vals2)){
//      const _r = bf.myCM_upd(bf.myCM_upd(bf.myCM_upd(pd_vals1, pd_vals2), ic.gd_stss1), ic.gd_stss2);
      let _r = pd_vals1;
      if (bf.f(pd_vals2)) _r = bf.myCM_upd(_r, pd_vals2);
      _r = bf.myCM_upd(_r, ic.gd_stss1);
      _r = bf.myCM_upd(_r, ic.gd_stss2);
      return _r;
    }
    else {
      const _r = bf.myCM_upd(bf.myCM_upd(pd_vals1, ic.gd_stss1), ic.gd_stss2);
      return _r;
    };
*/
    let _r = pd_vals1;
    if (bf.f(pd_vals2)) _r = bf.myCM_upd(_r, pd_vals2);
    _r = bf.myCM_upd(_r, ic.gd_stss1);
    _r = bf.myCM_upd(_r, ic.gd_stss2);
    return _r;
  };

  static myRN_chk_os(p_os) {
    let _r = false;
    if (Platform.OS == 'android' && p_os == 'a') {
      _r = true;
    };
    if (Platform.OS == 'ios' && p_os == 'i') {
      _r = true;
    };
    if (Platform.OS == 'web' && p_os == 'w') {
      _r = true;
    };
    return _r;
  };

  static myRN_chk_tkn(po_fnc1, po_fnc2) {
    if ( bf.f(global.c?.state.sgc_user_key) && bf.f(global.c?.state.sgc_tkn)) { // user_key および tkn が設定されている場合
      let _cnd1 = `"_KEY"={} AND "user3210"='{}'`.f(global.c?.state.sgc_user_key, global.c?.state.sgc_tkn);
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: 'user', 
        n_dms: 2, 
        cnd: _cnd1
      })
      .then( _d_users =>{
        if (bf.f(_d_users)) { // tkn が一致していた場合
          if (po_fnc1) {
            po_fnc1();
          };
        }
        else { // tkn が誤っていた場合
          if (po_fnc2) {
            po_fnc2();
          };
        };
      });
    }
    else { // user_key または tkn が設定されていない場合
      if (po_fnc2) {
        po_fnc2();
      };
    };
  };

  static myRN_cnv(p_mode, pa_val){
    if (p_mode == 'ecdBase64') { // encoded base64 日本語未対応？
//      return (pa_val) ? base64.encode(pa_val) : null;
      const Buffer = require("buffer").Buffer;
      return (pa_val) ? new Buffer(pa_val).toString('base64') : null;
    };

    if (p_mode == 'dcdBase64') { // decoded base64
//      return (pa_val) ? base64.decode(pa_val) : null;
      return (pa_val) ? base64.decode(pa_val) : null;
    };
  };

  static myRN_get_mimeType(p_file) {
    return mime.lookup(p_file);
  };

  static myRN_get_uri(p_str) {
    //
    if (!bf.f(p_str) || p_str.slice(0,1) != '{') {
      return null;
    };
    //
    return '{}/{}'.f(ic.g_url2, bf.p(p_str).file)
  };

  static myRN_get_stss() { // get state // 永続化対象のみが対象
    return new Promise( async _o_end1 => {
      let _d_stss = {};
      for await (let [_key, _val] of bf.e(ic.gd_stss1)) {
        _d_stss[_key] = global.c?.state[_key];
      };
      _o_end1(_d_stss);
    });
  };

  static myRN_ldr_show() { // show loader
    return new Promise( _o_end1 => {
      global.c?.setState({
        sgcn_prs: 0,
        sgcb_showLdr: true
      }, () =>{
        _o_end1();
      });
    });
  }

  static myRN_ldr_hide() { // hide loader
    return new Promise( _o_end1 => {
      global.c?.setState({
        sgcn_prs: 0,
        sgcb_showLdr:false
      }, () =>{
        _o_end1();
      });
    });
  }

  static myRN_mdl_show() { // show modal
    global.c?.setState({sgcb_showMdl:true});
  }

  static myRN_mdl_hide() { // show modal
    global.c?.setState({sgcb_showMdl:false});
  }

  static myRN_msg_get_grpKey(p_elm ,p_key){ // get message group Key
    return new Promise( _o_end1 => {
      let _cnd = bf.q('[ct21l11e]="{}" AND [ct21l11k]="{}"'.f(
        p_elm,
        p_key,
      ));
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: 'ct21', 
        n_dms: 2, 
        cnd: _cnd
      })
      .then( _d_ct21s => {
        if (bf.f(_d_ct21s)) { // メッセージグループが存在した場合
          _o_end1(_d_ct21s._KEY);
        }
        else { // メッセージグループが存在しなかった場合は追加
          let _d_vals = {
            ct21l11e: p_elm,
            ct21l11k: p_key,
            ct21c110: '',
            ct21cz10: '10',
          };
          cf.myCB_call_iud({
            ctr: 'ins', 
            elm: 'ct21', 
            d_vals: _d_vals
          })
          .then( _d_ct21s => {
            _o_end1(_d_ct21s._KEY);
          });
        };
      });
    });
  };

  static myRN_msg_cnv_msg(pld_ct20ss){ // get message
    return new Promise(async _o_end1 => {
      //
      let _r = [];
      let _dd_cashss = {};
      //
      for await (let [_idx, _d_ct20s] of bf.e(pld_ct20ss)) {
        //
        // 登録者情報の取得
        let _cnd2 = bf.q('[_KEY]={}'.f(_d_ct20s.ct20cy20))
        await cf.myCB_call_rfr(_d_ct20s, 'cm10', _cnd2, '', _dd_cashss)
        .then(async _d_ct20s => {
          //
          if (_d_ct20s.ct20c410 == '10'){ // メッセージの場合
            _r.push({
              type: 'msg',
              chb: false,
              key: '{_KEY}'.f2(_d_ct20s),
              name: '{cm10c310}'.f2(_d_ct20s),
              msg: '{ct20c610}'.f2(_d_ct20s),
              time: '{ct20cy10}'.f2(_d_ct20s),
              sort: '{ct20cy10}'.f2(_d_ct20s),
              vals: _d_ct20s,
            });
          };
          if (_d_ct20s.ct20c410 == '20'){ // ファイルの場合
            //
            // ファイル情報の取得
            let _cnd3 = bf.q('[ct10l11e]="ct20" AND [ct10l11k]="{}"'.f(_d_ct20s._KEY));
            await cf.myCB_call_rfr(_d_ct20s, 'ct10', _cnd3, '')
            .then( _d_ct20s => {
              //
              if (bf.f(_d_ct20s.ct10c610)) {
                _r.push({
                  type: 'file',
                  chb: false,
                  key: '{_KEY}'.f2(_d_ct20s),
                  name: '{cm10c310}'.f2(_d_ct20s),
                  file: {
                      name: bf.j('{ct10c610}'.f2(_d_ct20s)).name,
                      url: '{}/{}'.f(ic.g_url2,bf.j('{ct10c610}'.f2(_d_ct20s)).file),
                  },
                  time: '{ct20cy10}'.f2(_d_ct20s),
                  sort: '{ct20cy10}'.f2(_d_ct20s),
                  vals: _d_ct20s,
                });
              };
            });
          };
        })
      };
      _o_end1(_r);            
    });
  };

  static myRN_msg_upd_lastDtm(p_ct21Key, p_cm10Key){
    let _d_vals = {
      ct22b11k: p_ct21Key,
      ct22b21k: p_cm10Key,
//      ct22cz10: '10',
      ct22i110: bf.myDT_get_now(),
    }
    let _cnd =  bf.q('[ct22b11k]="{}" AND [ct22b21k]="{}"'.f(
      p_ct21Key,
      p_cm10Key,
    ));
    cf.myCB_call_iud({
      ctr: 'ups', 
      elm: 'ct22', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then(()=>{
      // 未読件数の初期化
      global.c?.setState({
          sgcn_msgCnt: 0,
      });
    })
  };

  static myRN_pll(plo_pmss, pb_ldr=true) { // parallel
    return new Promise( _o_end1 => {
      if (pb_ldr) cf.myRN_ldr_show();
      Promise.all(plo_pmss)
      .then(async _lb_ress =>{
        if (pb_ldr) cf.myRN_ldr_hide(); 
        let _b = true;
        for await (let [_idx, _b_res] of bf.e(_lb_ress)){
          if (_b_res == false) { // 各 pms の戻り値に一つでも false が存在する場合は false を返す
            _b = false;
            break;
          };
        };
        _o_end1(_b); // myRN_ldr_hide の後に then した場合、正しく処理されない場合がある模様
      })
      .catch((_err) => {
        alert('1055:{}, {}'.f(_err, plo_pmss))
      })
    });
  };

  static myRN_load = (plo_pmss) => new Promise( _o_end1 => {
    cf.myRN_pll(plo_pmss)
    .then(()=>{
      _o_end1();
    });
  });

  static myRN_ins(po_pms) { // sgc_pageKey への設定は、個別に行う必要がある
    return po_pms
    .then( _d_is => {
//bf.l('myRN_ins 1847:{}'.f(_d_is));
      new Promise( _o_end1 => {
        if (bf.f(_d_is)) {
          global.c?.setState({
            sgc_pageKey: _d_is._KEY
          }, ()=>{
            _o_end1();
          });
        }
        else {
          _o_end1();
        };
      })
      .then(()=>{
        global.c?.upd();
      });
    });
  };

  static myRN_upd(plo_pmss) {
    cf.myRN_pll(plo_pmss)
    .then(()=>{
      cf.myRN_set_pageMode('show')
      .then(()=>{
        global.c?.load();
      });
    });
  };

//  static myRN_move_fwd(pd_pageInfs) {
  static myRN_move_fwd(pd={}) {
/*
    if (bf.f(global.c?.state.sgc_pageName)) {
      let _ld = global.c?.state.sgcld_pageInfHstss; // immer の場合、push / pop できなくなる模様
      _ld.push({
        sgc_pageRole: global.c?.state.sgc_pageRole, 
        sgc_pageName: global.c?.state.sgc_pageName, 
        sgcd_pagePntKeys: global.c?.state.sgcd_pagePntKeys,
        sgc_pageKey: global.c?.state.sgc_pageKey,
        sgc_pageMode: global.c?.state.sgc_pageMode,
        sgc_pagePrc: global.c?.state.sgc_pagePrc,
        sgcn_tab: global.c?.state.sgcn_tab,
      });
      global.c?.setState({
        sgcld_pageInfHstss: _ld,
      });
    };
*/
/*
    global.c?.setState(pd, ()=>{ // この段階で sgc_pageRole が変更されることにより d_hdrs の d_leftBtns が変更されリロードが生ずるため、state を変更しない方式に改善要
      cf.myRN_get_stss()
      .then( _d_stss => {
        cf.myNV_stt_move(_d_stss);
      }); // ここの global.c は、遷移前の画面
    });
*/
    new Promise( _o_end1 => {
      if (global.c?.onExit) { // 遷移前の画面の onLeave
        global.c?.onExit(pd)
        .then(() => {
          _o_end1();
        });
      }
      else {
        _o_end1();
      };
    })
    .then( () => {
      global.c?.setState(pd, ()=>{ // この段階で sgc_pageRole が変更されることにより d_hdrs の d_leftBtns が変更されリロードが生ずるため、state を変更しない方式に改善要
        cf.myRN_get_stss()
        .then( _d_stss => {
//alert('2803:{}'.f(_d_stss))
          cf.myNV_stt_move(_d_stss);
        });
      });
    });
  };

  static myRN_move_bwd() {
    let _ld = global.c?.state.sgcld_pageInfHstss; // immer の場合、push / pop できなくなる模様
//bf.l('2822: {}'.f(_ld))
    if (bf.f(_ld)) { // 元ページが存在する場合
      let _d_pageInfs = _ld.pop();
      global.c?.setState({
        sgcld_pageInfHstss: _ld
      }, () => {
        global.c?.setState(_d_pageInfs, () => {
          cf.myRN_get_stss()
          .then((_d_stss)=>{
            cf.myNV_stt_move(_d_stss);
          });
        });
      });
    }
    else { // 元ページが存在しない場合
      const _d_pageInfs = iv.get_bwdPageInfs();
      global.c?.setState(_d_pageInfs, () => {
        cf.myRN_get_stss()
        .then((_d_stss)=>{
          cf.myNV_stt_move(_d_stss);
        });
      });
    };
  };

  static myRN_logout() {
    // 遷移履歴の削除
    global.c?.setState({ // global.c? が存在する場合のみ実行
      sgcld_pageInfHstss: [],
    });

    // LS の削除
    cf.myLS_clr() // global.c? が存在しなくとも実行
    .then(()=>{
      // TOP 画面へ遷移
      let _d_pageInfs = {
        sgc_pageRole: ic.g_iniPageRole,
        sgc_pageName: ic.g_iniPageName,
        sgcd_pagePntKeys: {},
        sgc_pageKey: '',
        sgc_pageMode: 'show',
        sgc_pagePrc: '',
        sgcb_pageEdt: false,
      };
      cf.myNV_stt_move(_d_pageInfs); // global.c? を極力介さないため、myRN_move_fwd は使用しない
    });

  };


  static myRN_clr_pageInf(po_fnc=null) {
    global.c?.setState({
      sgc_pageName: '',
      sgc_pageMode: '',
      sgc_pagePrc: '',
      sgcb_pageEdt: false,
      sgcld_pageInfHstss: [],
    }, ()=>{
      if (po_fnc) {
        po_fnc();
      };
    });
  };

/*
  static myRN_adjPtn(pd={ // adjust position
    o_this: null,
    ctr: '', // ctr : set/clr
  }) {
    let _o_this = pd.o_this ?? global.c;
    if (_o_this) {
bf.l('2896: {}, {}'.f(pd.ctr, _o_this.state.sgcdd_ptnss))
      switch (pd.ctr) {
        case 'stt':
          _o_this.setState({
            sgcdd_ptnss: bf.p( _o_this.state.sgcdd_ptnss, _next => {
              _next.b_adj = true;
  //            let _dy = (_next.d_msrs.y + _next.d_msrs.h) - (_next.d_kbds.screenY);
//              let _dy = (_next.d_msrs.y + (_next.d_msrs.h ?? 0)) - (_next.d_kbds.screenY ?? 0) - (ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5);
              let _dy = (_next.d_msrs.y + (_next.d_csrs.y ?? (ic.gn_fontSizeNrm + ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5))) - (_next.d_kbds.screenY ?? 0);
//              if (_dy <= 0) _dy = 0; // 下側が被った場合のみが対象
//              if (_dy >= _next.d_kbds.height) _dy = _next.d_kbds.height; // キーボード分のみが対象
              _next.n_hdrDy = _dy;
bf.l('2907: {}, {}, {}'.f(pd.ctr, _next.n_hdrDy, _dy))
            }),
          }, () => {
          });
          break;
        case 'set':
          if ( _o_this.sgcdd_ptnss?.b_adj == true ) {
            _o_this.setState({
              sgcdd_ptnss: bf.p( _o_this.c?.state.sgcdd_ptnss, _next => {
  //            let _dy = (_next.d_msrs.y + _next.d_msrs.h) - (_next.d_kbds.screenY);
//                let _dy = (_next.d_msrs.y + (_next.d_msrs.h ?? 0)) - (_next.d_kbds.screenY ?? 0) - (ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5);
              let _dy = (_next.d_msrs.y + (_next.d_csrs.y ?? (ic.gn_fontSizeNrm + ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5))) - (_next.d_kbds.screenY ?? 0);
//                if (_dy <= 0) _dy = 0; // 下側が被った場合のみが対象
//                if (_dy >= _next.d_kbds.height) _dy = _next.d_kbds.height; // キーボード分のみが対象
                _next.n_hdrDy = _dy;
bf.l('2921: {}, {}, {}'.f(pd.ctr, _next.n_hdrDy, _dy))
              }),
            }, () => {
            });
          };
          break;
        case 'end':
          _o_this.setState({
            sgcdd_ptnss: bf.p( _o_this.state.sgcdd_ptnss, _next => {
              _next.b_adj = false;
              _next.n_hdrDy = 0;
            }),
          }, () => {
          });
          break;
        default:
          alert('incorrect ctr at myRN_adjPtn');
          break;
      };
    }
  };
*/

  static myRN_getDy = (po_this) => { // キーボードの表示に伴う移動量 android の場合、_dy が実態と一致するよう調整した後、Hdr の top を調整
    if (po_this.state.sgcd_msrs.y == undefined) return 0;
    let _dy = (po_this?.state.sgcd_msrs.y + po_this?.state.sgcd_msrs.h) - (po_this?.state.sgcd_kbds.screenY);
    if (_dy >= (po_this?.state.sgcd_kbds.height - ic.gn_ftrH)) _dy = po_this?.state.sgcd_kbds.height - ic.gn_ftrH; // キーボード分のみが対象
    if (_dy < 0) _dy = 0; // 下側が被った場合のみが対象
//    _dy = (cf.myRN_chk_os('a') == true) ? 0 : _dy;
    return _dy;
  };

  static myRN_stt(po_this, po_fnc) { // この中では、global.c ではなく po_this を使用
    po_this.d_crls = {
      b_mnt: true,
    }; // mounted

    //
/*
    if (!cf.myRN_chk_os('w')){ // version check
      cf.myCB_call_ver()
      .then((_d_ress)=>{
        if (_d_ress.result != ic.g_ver) { // バージョンをチェックし、最新化
          //alert('データを最新化するため、アプリを再起動します\n（複数回、行わなければならない場合があります）');
          //Updates.reloadAsync();
          alert('最新のプログラムをダウンロードください。');
        };
      })
      .catch((_err)=>{
        alert('1458:'+bf.s(_err));
      })
    };
*/

/*
    po_this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
      if (po_this.state.sgcd_msrs.y == undefined) {
        return;
      };
      let _dy = (po_this?.state.sgcd_msrs.y + po_this?.state.sgcd_msrs.h) - (ic.gn_h - _e.endCoordinates.height);
      if (_dy <= 0) { // 下側が被った場合のみが対象
        _dy = 0;
      }
      if (_dy >= _e.endCoordinates.height - ic.gn_bdyY) { // キーボード分のみが対象
        _dy = _e.endCoordinates.height - ic.gn_bdyY;
      }
      po_this.setState({
        sgcn_bdyY: ic.gn_bdyY - _dy - po_this?.state.sgcn_adjY,
      });
    });

    po_this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', (_e) => {
      po_this.setState({
        sgcn_bdyY: ic.gn_bdyY,
      });
    });
*/
    //
/*
    po_this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
bf.l('2910: {}, {}'.f(po_this?.state.sgcd_msrs, _e.endCoordinates))
      if (po_this.state.sgcd_msrs.y == undefined) return;
      let _dy = (po_this?.state.sgcd_msrs.y + po_this?.state.sgcd_msrs.h) - (ic.gn_h - _e.endCoordinates.screenY);
      if (_dy <= 0) _dy = 0; // 下側が被った場合のみが対象
      if (_dy >= _e.endCoordinates.height) _dy = _e.endCoordinates.height; // キーボード分のみが対象
      po_this.setState({
        sgcn_bdyY: ic.gn_bdyY - _dy - po_this?.state.sgcn_adjY,
        sgcn_hdrY: _e.endCoordinates.height - po_this?.state.sgcd_msrs.h - ic.gn_mgnNrm,
        sgcd_kbds: _e.endCoordinates,
      });
    });

    po_this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', (_e) => {
      po_this.setState({
        sgcn_bdyY: ic.gn_bdyY,
        sgcn_hdrY: ic.gn_hdrY,
        sgcd_kbds: _e.endCoordinates,
      });
    });
*/

/*
    po_this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
bf.l('2910: {}, {}'.f(po_this?.state.sgcd_msrs, _e.endCoordinates))
      if (po_this.state.sgcd_msrs.y == undefined) return;
      let _dy = (po_this?.state.sgcd_msrs.y + po_this?.state.sgcd_msrs.h) - (_e.endCoordinates.screenY);
      if (_dy <= 0) _dy = 0; // 下側が被った場合のみが対象
      if (_dy >= _e.endCoordinates.height) {
        _dy = _e.endCoordinates.height
      } // キーボード分のみが対象
      po_this.setState({
        sgcn_bdyY: ic.gn_bdyY - _dy - po_this?.state.sgcn_adjY,
//        sgcn_hdrY: _e.endCoordinates.height - po_this?.state.sgcd_msrs.h - ic.gn_mgnNrm,
        sgcd_kbds: _e.endCoordinates,
      });
    });
*/
/*
    po_this.keyboardDidShowListener = Keyboard.addListener('keyboardWillShow', (_e) => { //_e.endCoodinates.height : keyboard height
alert('3043: hello')
    });
*/
    po_this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
        if (bf.f(po_this.state.sgcd_kbds) == false) { // この判定がないと、表示がばたつく
          po_this.setState({
            sgcd_kbds: _e.endCoordinates,
          }, () =>{
            if (cf.myRN_chk_os('a') == false) {
              po_this.setState({
                sgcn_dy: cf.myRN_getDy(po_this),
              });
            };
          });
        }
    });

    po_this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', (_e) => {
        po_this.setState({
          sgcd_kbds: {},
        }, () => {
          if (cf.myRN_chk_os('a') == false) {
            po_this.setState({
              sgcn_dy: 0,
            });
          };
        });
    });

/*
    po_this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
bf.l('2934: {}, {}'.f(po_this?.state.sgcd_msrs, _e.endCoordinates))
      if (po_this.state.sgcd_msrs.y == undefined) {
        return;
      };
      let _dy = (po_this?.state.sgcd_msrs.y + po_this?.state.sgcd_msrs.h) - (_e.endCoordinates.screenY);
      if (_dy <= 0) { // 下側が被った場合のみが対象
        _dy = 0;
      }
      if ( _dy >= _e.endCoordinates.height) { // キーボード分のみが対象
        _dy = _e.endCoordinates.height;
      }
      po_this.setState({
        sgcn_dy: _dy +  ic.sgcn_adjY,
      });
    });
    //
    po_this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', (_e) => {
bf.l('2934: {}, {}'.f(po_this?.state.sgcd_msrs, _e.endCoordinates))
      po_this.setState({
        sgcn_dy: 0,
      });
    });
*/

/*
    po_this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
      po_this.setState({
        sgcdd_ptnss: bf.p( po_this.state.sgcdd_ptnss, _next => {
          _next.d_kbds = _e.endCoordinates;
        }),
      }, () => {
        cf.myRN_adjPtn({
          o_this: po_this,
          ctr: 'stt'
        });
      });
    });

    po_this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', (_e) => {
      po_this.setState({
        sgcdd_ptnss: bf.p( po_this.state.sgcdd_ptnss, _next => {
          _next.d_kbds = _e.endCoordinates;
        }),
      }, () => {
        cf.myRN_adjPtn({
          o_this: po_this,
          ctr: 'end'
        });
      });
    });
*/


    po_this.dmnLnr = Dimensions.addEventListener('change', _evt => { // dimensions listener
      po_this.setState({
        sgcd_dmns: {
          n_w: _evt.window.width,
          n_h: _evt.window.height,
          n_bdyW:
            (_evt.window.width > ic.gn_maxBdyW) ?
              ic.gn_maxBdyW
            : (_evt.window.width < ic.gn_minBdyW) ?
              ic.gn_minBdyW
            : _evt.window.width
          ,
          n_bdyH: _evt.window.height - (ic.gn_hdrH + ic.gn_ftrH),
        },
      }, () => {
//bf.l('3192: {}'.f(po_this.state.sgcd_dmns))
      });
    });

    po_this.focusListener = po_this.props.navigation.addListener("focus", () => { // 画面遷移時に再描画するために必要 2/4 po_this は旧・global.c は新であることに注意
      //
      if (po_this.d_crls?.b_mnt != true) return;
//alert('2929: {}'.f(global.c?.props.route.name))
      global.c = po_this; // current component, defined at ic.js、move_bwd で切り替わることを考慮し willFocux の中で設定
//alert('2931: {}'.f(po_this.props.route.name))
      cf.myNV_end_move( po_this )
      .then( _d_vals => {
        po_this.setState(_d_vals, ()=>{ // この段階で、前コンポーネントからの情報が引き継がれる、global.c にした場合、move_bwd で実行されない模様
          //
          StatusBar.setHidden(true); // status bar を非表示
          //
          cf.myRN_pll([
            new Promise(_o_end1 => {
              cf.myLS_get('cm10_key')
              .then((_cm10_key) => {
                po_this.setState({
                  sgc_cm10_key: (bf.f(_cm10_key)) ? _cm10_key : ''
                }, ()=>{
                  _o_end1();
                });
              });
            }),
            new Promise(_o_end1 => {
              cf.myLS_get('tkn').then((_tkn) => {
                po_this.setState({
                  sgc_tkn: (_tkn) ? _tkn : ''
                }, ()=>{
                  _o_end1();
                });
              });
            }),
            new Promise(_o_end1 => {
              cf.myLS_get('eml').then((_eml) => {
                po_this.setState({
                  sgc_eml: (_eml) ? _eml : ''
                }, ()=>{
                  _o_end1();
                });
              });
            }),
          ])
          .then(()=>{

            if ( ic.gb_setCm31 == true ) {
              cf.myCB_call_tree({
                ctr: 'slc',
                state: 'sgcdld_cm31sss',
                dd_elmDefss: {
                  cm31: {
                    elm: 'cm31',
                    o_cnd: _dd_datss => {
                      let _cnd = bf.q(`
                        [cm31b11k]="{}" AND
                        [cm31b31k]="{}" AND
                        IFNULL([cm31cz10],"10")<>"0"
                      `.f(
                        po_this.state.sgcd_pagePntKeys?.cm20_key,
                        po_this.state.sgcd_pagePntKeys?.cm10_key,
                      ));
                      return _cnd;
                    },
                  },
                },
              });
            }

            let _pageName = po_this.props.route.name;
            if (_pageName != ic.g_iniPageName &&
              bf.f(po_this.state.sgc_cm10_key)
            ) {
              let _cnd = bf.q('[_KEY]={}'.f(
                po_this.state.sgc_cm10_key,
              ));
              cf.myCB_call_slc({
                ctr: 'nlm', 
                elm: 'cm10', 
                n_dms: 3, 
                cnd: _cnd,
                do_rfrs: {
                  cm1i: () => bf.q('[cm1ib11k]="{}"'.f(
                    po_this.state.sgc_cm10_key,
                  )),
                },
              })
              .then( _ld_cm10ss => {
                if (bf.f(_ld_cm10ss)) {
                  let _d_cm10s = _ld_cm10ss[0];
                  let _pageRole = iv.o_gdd_ftrDefss()[po_this.state.sgc_pageRole][_pageName].role;
                  po_this.setState({
                    sgc_user_key: _d_cm10s.cm10b11k,
                    sgc_cm10c310: _d_cm10s.cm10c310,
                    sgc_cm10c410: _d_cm10s.cm10c410,
                    sgc_pageRole: _pageRole,
                    sgc_cm1ii410: _d_cm10s.cm1ii410,
                  }, ()=>{
                    if (po_fnc){
                      po_fnc();
                    };
                  });
                }
                else {
                  cf.myRN_logout();
                }
              });
            }
            else{
              if (_pageName == ic.g_iniPageName) {
                if (po_fnc){
                  po_fnc();
                };
              }
              else {
                cf.myRN_logout();
              }
            };
          })
        });
      });
    });
  };

  static myRN_end() { // 他の画面から戻ってくるごとに実行される、global.c?.focusListener を記載した場合、戻ってきた際に myRN_stt の addListner が実行されず global.c　が設定されない模様
    if (global.c?.d_crls) global.c.d_crls.b_mnt = false;
    global.c?.focusListener.remove();
    global.c?.keyboardDidShowListener.remove();
    global.c?.keyboardDidHideListener.remove();
    global.c?.dmnLnr.remove();
  };

static myRN_eptCsv = (pd={
  name: '',
  hdr: '',
  op_bldVal: _ld_valss => new Promise( _o_end1 => {}),
  ld_sortss: [
    {fld:'', dtn:'desc/asc', mode:'nmb/str'},
  ],
  o_listVal: d_vals => ({}),
}) => {

  let _ld_valss = [];
  let _dd_cashss = {};

  cf.myRN_ldr_show();

  pd.op_bldVal(_ld_valss, _dd_cashss)
  .then( () => {
//bf.l('3081: here')

    let _csv = bf.myCM_sort({      // 並べ替え
      ld_itemss: _ld_valss,
      ld_sortss:pd.ld_sortss,
    })
    .reduce( (_prev1, _d_vals) => {      // CSV生成
      let _s = pd.o_listVal(_d_vals)
      .reduce( (_prev2, _val) => {
        return ((_prev2 != '') ? '{},'.f(_prev2) : '') + '"{}"'.f(_val)
       }, '');
      return _prev1 + '\n' + _s
    }, pd.hdr);

    if ( cf.myRN_chk_os('w') ) { // web の場合
//bf.l('3101: {}'.f(_csv))
      df.myFL_ept({      // ファイル出力
        fileName: '{}_{}.csv'.f(
          pd.name, 
          bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)
        ),
//        text: _csv,
        val: _csv,
      });
      cf.myRN_ldr_hide();
    }
    else { // web 以外の場合
//bf.l('3111: {}'.f(_csv))
      cf.myRN_ept({
        fileName: '{}_{}.csv'.f(
          pd.name, 
          bf.myDT_get_now().replace(/ /g, '-').replace(/-/g, '').replace(/:/g, '').substr(0,12)
        ),
        val: _csv,
      });
      cf.myRN_ldr_hide();
    };
  })
};

static async myRN_ept(pd={ // react native file export
  fileName: '',
  val: '',
}) {
  let _fileUri = FileSystem.documentDirectory + encodeURI(pd.fileName); // 日本語ファイル名への対応
  await FileSystem.writeAsStringAsync(_fileUri, pd.val, { encoding: FileSystem.EncodingType.UTF8 });
  await Sharing.shareAsync(_fileUri)
};

static myRN_chkIpt = (pd={
  type: '',
  name: '',
  d_is: {},
  d_rs: {},
  elm: '', // ID
  o_cndElm: _d_is => {}, // ID
  l_insRoles: [], // ID
  l_updRoles: [], // ID
  o_cndCm31: _d_elms => {}, // 部門, ロール, ID
  l_roles: [], // ロール
  b_chkEtc: false, // ID　check existence
  dd_cashss: {
    elm: {
      cnd: {},
    },
  },
}) => new Promise( async _o_end1 => {

  let _dd_cashss = pd.dd_cashss || {};

//bf.l(`3334: {}, {}, {}`.f(pd.type, pd.name, pd.d_is))  
  switch (pd.type) {

    case 'ID':
      if (bf.f(pd.d_is['{}'.f(pd.name)]) == false) { // IDが指定されていない
        pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '{}が設定されていません'.f(pd.name);
        _o_end1(false);
      }
      else {
        let _cnd = pd.o_cndElm();
        cf.myCB_call_slc({ // 汎用性を持たせるため call_slc にて対応
          ctr: 'nlm',
          elm: pd.elm,
          n_dms: 2,
          cnd: _cnd, // elm id の抽出条件
          dd_cashss: _dd_cashss,
        })
        .then( _d_elms => {
          pd.d_rs['d_{}s'.f(pd.elm)] = _d_elms || {};
          if (bf.f(_d_elms) == false) { // 指定したIDが登録されておらず、追加する場合）
            if ( pd.b_chkEtc == true ) { // 存在チェックを行う場合
              pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '指定された{}が登録されていません'.f(pd.name);
              _o_end1(false);
            }
            else {
              if (
                bf.f(pd.l_insRoles) == true && 
                bf.i(global.c?.state.sgc_pageRole, pd.l_insRoles) == false
              ) {
                pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '設定された{}を追加する権限がありません'.f(pd.name);
                _o_end1(false);
              }
              else {
                if (pd.o_insCndCm31) {
                  cf.myCB_call_slc({
                    ctr: 'nlm',
                    elm: 'cm31',
                    n_dms: 2,
                    cnd: pd.o_insCndCm31(_d_elms), // cm31 の抽出条件
                    dd_cashss: _dd_cashss,
                  })
                  .then( _d_cm31s => {
                    if (bf.f(_d_cm31s) == false ) { // 指定されたIDに対する権限がない
                      pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '設定された{}に対する変更権限がありません'.f(pd.name);
                      _o_end1(false);
                    }
                    else { // 運営者の確認はロールで行う
                      _o_end1(true);
                    }
                  });
                }
                else {
                  _o_end1(true);
                };
              }
            };
          }
          else { // 指定した ID が登録されており、上書する場合
            if (
              bf.f(pd.l_updRoles) == true &&
              bf.i(global.c?.state.sgc_pageRole, pd.l_updRoles) == false
            ) {
              pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '設定された{}を上書する権限がありません'.f(pd.name);
              _o_end1(false);
            }
            else {
              if (pd.o_updCndCm31) {
                cf.myCB_call_slc({
                  ctr: 'nlm',
                  elm: 'cm31',
                  n_dms: 2,
                  cnd: pd.o_updCndCm31(_d_elms), // cm31 の抽出条件
                  dd_cashss: _dd_cashss,
                })
                .then( _d_cm31s => {
                  if (bf.f(_d_cm31s) == false ) { // 指定されたIDに対する権限がない
                    pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '設定された{}に対して上書する権限がありません'.f(pd.name);
                    _o_end1(false);
                  }
                  else { // 運営者の確認はロールで行う
                    _o_end1(true);
                  }
                });
              }
              else {
                _o_end1(true);
              };
            }
          }
        });
      };
      break;

    case '本人': // b_chk
      if (pd.b_chk == true) { // 確認対象の場合
        let _cnd = bf.q(`
          [cm10b21k]="{}" AND
          [_KEY]={} AND 
          [cm10cw10]="{}"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgcd_pagePntKeys.cm10_key,
          pd.d_is[pd.name],
        ));
        cf.myCB_call_slc({ // 汎用性を持たせるため call_slc にて対応
          ctr: 'nlm',
          elm: 'cm10',
          n_dms: 2,
          cnd: _cnd, // elm id の抽出条件
          dd_cashss: _dd_cashss,
        })
        .then( _d_cm10s => {
          if ( bf.f(_d_cm10s) == false ) {
            pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '本人以外の{}が設定されています'.f(pd.name);
            _o_end1(false);
          }
          else {
            _o_end1(true);
          };
        });
      }
      else {
        _o_end1(true);
      };
      break;

    case '部門在籍': // b_chk, cm30_key
      if (pd.b_chk == true) { // 確認対象の場合
        let _cnd = bf.q(`
          [cm31b11k]="{}" AND
          [cm31b21k]="{}" AND
          [cm31b31k]=(
            SELECT
              [_KEY]::TEXT
            FROM
              [t_cm10]
            WHERE
              [cm10b21k]="{}" AND 
              [cm10cw10]="{}"
          ) AND
          IFNULL([cm31cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          pd.cm30_key || -1,
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          pd.d_is[pd.name],
        ));
        cf.myCB_call_slc({ // 汎用性を持たせるため call_slc にて対応
          ctr: 'nlm',
          elm: 'cm31',
          n_dms: 2,
          cnd: _cnd, // elm id の抽出条件
          dd_cashss: _dd_cashss,
        })
        .then( _d_cm31s => {
          if ( bf.f(_d_cm31s) == false ) {
            pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '部門に在籍していない{}が設定されています'.f(pd.name);
            _o_end1(false);
          }
          else {
            _o_end1(true);
          };
        });
      }
      else {
        _o_end1(true);
      };
      break;

    case '部門運営者': // b_chk, cm30_key
      if (pd.b_chk == true) { // 確認対象の場合
        let _cnd = bf.q(`
          [cm31b11k]="{}" AND
          [cm31b21k]="{}" AND
          [cm31b31k]="{}" AND
          [cm31c410]="20" AND
          IFNULL([cm31cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          pd.cm30_key || -1,
          global.c?.state.sgcd_pagePntKeys.cm10_key,
        ));
        cf.myCB_call_slc({ // 汎用性を持たせるため call_slc にて対応
          ctr: 'nlm',
          elm: 'cm31',
          n_dms: 2,
          cnd: _cnd, // elm id の抽出条件
          dd_cashss: _dd_cashss,
        })
        .then( _d_cm31s => {
          if ( bf.f(_d_cm31s) == false ) {
            pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '{}が登録されていないか、{}が属する部門に対して変更権限がありません'.f(pd.name, pd.name);
            _o_end1(false);
          }
          else {
            _o_end1(true);
          };
        });
      }
      else {
        _o_end1(true);
      };
      break;

    case '数値':
      if (
        bf.f(pd.d_is['{}'.f(pd.name)]) == true && 
        bf.myCM_chk_type(pd.d_is['{}'.f(pd.name)], 'nmb') == false
      ) {
        pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '{}は「数値」のみを設定ください'.f(pd.name);
        _o_end1(false);
      }
      else {
        _o_end1(true);
      };
      break;

    case '区分値':
      if (
        bf.f(pd.d_is[pd.name]) == true && 
        bf.i(pd.d_is[pd.name], pd.l_is) == false
      ) {
        pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + '{}は「{}」のみを設定ください'.f(pd.name, pd.l_is.join('/'));
        _o_end1(false);
      }
      else {
        _o_end1(true);
      };
      break;

    default:
//      pd.d_rs.msg += ((bf.f(pd.d_rs.msg)) ? '/' : '') + 'incorrect type at myRN import check';
//      _o_end1(false);
      bf.l('3586: incorrect type at myRN import check {}'.f(pd.type));
      break;
  };
});

static myRN_iptCsv = async (pd={
  olp_bfrs: (_d_is, _d_rs, _dd_cashs) => [
    new Promise( _o_end1 => {}),
  ],
  olp_chks: (_d_is, _d_rs) => [
    new Promise( _o_end1 => {}),
  ],
  od_bldIuds: (_d_is, _d_rs) => {},
}) => {

  let _dd_cashss = {}; // データ抽出時のキャッシュ

  const _op_fnc1 = (pd2={
    elm: '',
    d_pnts: {},
    o_cnd: _d_pnts => '',
    od_insVals: _d_pnts => ({}),
    od_updVals: _d_pnts => ({}),
    ld_cldss: [],
  }) => new Promise( _o_end1 => {

    new Promise( _o_end2 => {
      let _cnd = pd2.o_cnd(pd2.d_pnts);
      cf.myCB_call_slc({ 
        ctr: 'nlm',
        elm: pd2.elm,
        n_dms: 2,
        cnd: _cnd,
        dd_cashss: null, // ！！！！！　キャッシュを使用しない　！！！！！　（現時点の情報を元に処理するため）
      })
      .then( _d_elms => {
        if (bf.f(_d_elms) != true) { // 新規登録の場合
//bf.l('3611: {}, {}'.f(_cnd, _d_elms));
          let _d_iuds = pd2.od_insVals(pd2.d_pnts);
          if (pd2.elm != 'user') { // 一時的に除外
            _d_iuds = bf.c(_d_iuds, {
              ['{}cy10'.f(pd2.elm)]: bf.myDT_get_now(),
              ['{}cy20'.f(pd2.elm)]: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
            });
          };
//bf.l('3619: {}'.f(_d_iuds));
          cf.myCB_call_iud({
            ctr: 'ins',
            elm: pd2.elm,
            d_vals: _d_iuds,
          })
          .then( _d_ress => {
//bf.l('3626: {}'.f(_d_ress));
            let _d = bf.c(bf.c(bf.c(pd2.d_pnts || {}, _d_ress), {['{}_key'.f(pd2.elm)]: _d_ress._KEY}), _d_iuds);
            _o_end2(_d); // 戻り値に被せる
          });
        }
        else {
//bf.l('3632: here');
          let _d_iuds = (pd2.od_updVals) ? pd2.od_updVals(pd2.d_pnts) : {};
          let _d_iuds2 = {};
          Object.keys(_d_iuds)
          .map( _fld => {
            if (_d_iuds[_fld] != null) _d_iuds2[_fld] = _d_iuds[_fld];
          });
          if (bf.f(_d_iuds2) == true) {
            if (pd2.elm != 'user') { // 一時的に除外
              _d_iuds2 = bf.c(_d_iuds2, {
                ['{}cy10'.f(pd2.elm)]: bf.myDT_get_now(),
                ['{}cy20'.f(pd2.elm)]: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
              });
            };
//bf.l('3646: {}, {}'.f(_d_iuds2));
            cf.myCB_call_iud({
              ctr: 'upd',
              elm: pd2.elm,
              d_vals: _d_iuds2,
              cnd: _cnd,
            })
            .then( _d_ress => {
              let _d = bf.c(bf.c(bf.c(pd2.d_pnts || {}, _d_elms), {['{}_key'.f(pd2.elm)]: _d_elms._KEY}), _d_iuds2);
              _o_end2(_d); // 検索値に被せる
            });
          }
          else {
//bf.l('3659: here');
            let _d = bf.c(bf.c(bf.c(pd2.d_pnts || {}, _d_elms), {['{}_key'.f(pd2.elm)]: _d_elms._KEY}), _d_iuds2);
            _o_end2(_d); // 検索値に被せる
          };
        }
      })
    })
    .then( async _d_pnts => {
      if ( bf.f(pd2.ld_cldss) == true) {

        Promise.all(
          pd2.ld_cldss
          .map( async _d_clds => {
            _d_clds.d_pnts = _d_pnts;
            await _op_fnc1(_d_clds)
          })
        )
        .then(() => {
          _o_end1();
        });
      }
      else {
        _o_end1();
      }
    });
  });

  let _o_fnc2 = async (pd2={
    ld_iss: [],
  }) => {

//bf.l('3680: {}'.f(bf.myDT_get_now()));

    cf.myRN_ldr_show();

    global.c?.setState({
      sgcd_prss: bf.p( global.c?.state.sgcd_prss, _next => {
        _next.b_vsb = true;
        _next.n_wgt = 65;
        _next.n_ttlCnt += bf.myCM_get_len(pd2.ld_iss) * 2;
      }),
    });

/*
    let _ld_iss = 
    await Promise.all(
      pd2.ld_iss
      .map( (_d_is, _idx) => new Promise( _o_end1 => { // 1行ごとの処理

        let _d_rs = {
          pfx: '{}行目'.f(_idx + 1),
          sts: '-', // ok or ng
          msg:'', // エラー・警告メッセージ
          d_iuds: [], // 操作対象のデータ
          d_rfrs: {},
        };

        // 初期処理・事前チェック
        cf.myRN_pll(
          (pd.olp_bfrs) ? pd.olp_bfrs(_d_is, _d_rs, _dd_cashss) : [],
          false
        )
        .then(() => {

          global.c?.setState({
            sgcd_prss: bf.p( global.c?.state.sgcd_prss, _next => {
              _next.n_crrCnt += 1;
            }),
          });

          cf.myRN_pll(
            pd.olp_chks(_d_is, _d_rs, _dd_cashss),
            false
          )
          .then( _b_noErr => {

            global.c?.setState({
              sgcd_prss: bf.p( global.c?.state.sgcd_prss, _next => {
                _next.n_crrCnt += 1;
              }),
            });

            if ( _b_noErr != true ) { // エラーがあった場合
              _d_rs.sts = 'ng';
              _o_end1(_d_rs);
            }
            else { // エラーがなかった場合
              _d_rs.sts = 'ok';
              let _d_iuds = pd.od_bldIuds(_d_is, _d_rs); // olp_chks の処理結果を od_bldIuds にも共有 
              if (_d_iuds) _d_rs.d_iuds = _d_iuds;                    
              _o_end1(_d_rs);
            };
          });
        });
      }))
    );
*/
//bf.l('3746: {}'.f(bf.myDT_get_now()));
    let _ld_iss = [];
    for await (let [_idx, _d_is] of bf.e(pd2.ld_iss)) {

      let _d_rs = {
        pfx: '{}行目'.f(_idx + 1),
        sts: '-', // ok or ng
        msg:'', // エラー・警告メッセージ
        d_iuds: [], // 操作対象のデータ
        d_rfrs: {},
      };

        // 初期処理・事前チェック
        await cf.myRN_pll(
          (pd.olp_bfrs) ? pd.olp_bfrs(_d_is, _d_rs, _dd_cashss) : [],
          false
        )
        .then( async () => {

          global.c?.setState({
            sgcd_prss: bf.p( global.c?.state.sgcd_prss, _next => {
              _next.n_crrCnt += 1;
            }),
          });

          await cf.myRN_pll(
            pd.olp_chks(_d_is, _d_rs, _dd_cashss),
            false
          )
          .then( async _b_noErr => {

            global.c?.setState({
              sgcd_prss: bf.p( global.c?.state.sgcd_prss, _next => {
                _next.n_crrCnt += 1;
              }),
            });

            if ( _b_noErr != true ) { // エラーがあった場合
              _d_rs.sts = 'ng';
              _ld_iss.push(_d_rs);
            }
            else { // エラーがなかった場合
              _d_rs.sts = 'ok';
              let _d_iuds = await pd.od_bldIuds(_d_is, _d_rs); // olp_chks の処理結果を od_bldIuds にも共有 
              if (_d_iuds) _d_rs.d_iuds = _d_iuds;                    
              _ld_iss.push(_d_rs);
            };
          });
        });
    }

//bf.l('3798: {}'.f(bf.myDT_get_now()));
    let _n_errCnt = await _ld_iss
    .reduce( (_prev, _d_is) => { // true: エラーなし
      let _r = (_d_is.sts == 'ok') ? _prev : (_prev+1);
      return _r;
    }, 0);

//bf.l('3805: {}'.f(bf.myDT_get_now()));
    if ( _n_errCnt > 0 ) { // エラーありの場合
      let _s = _ld_iss
      .reduce( (_prev, _d_is) => {
        return (_d_is.sts == 'ok') ? _prev : _prev + '{}:{}\n'.f(_d_is.pfx, _d_is.msg)
      }, '');
      cf.myRN_ldr_hide();
      alert('CSVファイルに誤りがあるため、取り込みませんでした（{}件）\n{}'.f(_n_errCnt, _s));
    }
    else { // エラーなしの場合

      global.c?.setState({
        sgcd_prss: bf.p( global.c?.state.sgcd_prss, _next => {
          _next.n_wgt = 100;
          _next.n_ttlCnt += bf.myCM_get_len(pd2.ld_iss);
        }),
      });

/*
      let _l1 = [];
      let _l2 = [];
      _ld_iss.map( (_d_rs, _idx) => {
        _l2.push(_d_rs);
        if (_idx != 0 && _idx % 10 == 0) {
          _l1.push(_l2);
          _l2 = [];
        };
      });
      _l1.push(_l2);
      for await ( let [_idx1, _l2] of _l1.entries() ) { // データの重複登録が行われないよう注意
        await Promise.all(
          _l2.map( async (_d_rs, _idx2) => {
            await _op_fnc1(_d_rs.d_iuds);
            global.c?.setState({
              sgcd_prss: bf.p( global.c?.state.sgcd_prss, _next => {
                _next.n_crrCnt += 1;
              }),
            });
          })
        )
      };
*/
      for await ( let [_idx, _d_rs] of bf.e(_ld_iss) ) { // データの重複登録が行われないよう注意
        await _op_fnc1(_d_rs.d_iuds);
        global.c?.setState({
          sgcd_prss: bf.p( global.c?.state.sgcd_prss, _next => {
            _next.n_crrCnt += 1;
          }),
        });
      };

      global.c?.setState({
        sgcd_prss: bf.p( global.c?.state.sgcd_prss, _next => {
          _next.b_vsb = false;
          _next.n_crrCnt = _next.n_ttlCnt;
        }),
      });
      cf.myRN_ldr_hide();
//bf.l('3863: {}'.f(bf.myDT_get_now()));
      alert('CSVファイルの取り込みを終えました');
      if (pd.op_atr) {
        pd.op_atr()
        .then(() => {
          global.c?.load();
        });
      }
      else {
        global.c?.load();
      }
    };
  }; 

  if (cf.myRN_chk_os('w')) {
    global.c?.setState({
      sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
        _next.file.mode = 'csv';
        _next.file.b_showMdl = true;
        _next.file.onRead = _o_fnc2;
      }),
    });
  }
  else {
    cf.myFS_pck_file()
    .then( _d_files => {
      if (_d_files) {
        FileSystem.readAsStringAsync( _d_files.uri )
        .then( _s => {
          bf.myCM_cnvCsvToJson(_s)
          .then( _d_rs => {
            _o_fnc2(_d_rs);
          });
        })
      };
    });

  };


};

  static myRN_open_url = (p_url) => new Promise( _o_end1 => {
    if (cf.myRN_chk_os('w') == true) {
      window.open(p_url, '_blank');
      _o_end1();
    }
    else {
      Linking.openURL(p_url);
      _o_end1();
    }
  });

  static myRN_set_pageMode(p_pageMode) { // set pageMode
    return new Promise( _o_end1 => {
      global.c?.setState({
        sgc_pageMode:p_pageMode,
      }, () => {
        _o_end1();
      });
    })
  };

  static myRN_user_ins(p_eml){
    return new Promise ((_o_end1)=>{
      let _eml = bf.myCM_cnv('lwr', p_eml);
      let _d_vals = {
        user1010: _eml,
        user1020: bf.myCM_gnr(128),
        user1030: _eml,
      }
      let _cnd = bf.q('[user1010]="{}"'.f(_eml))
      cf.myCB_call_iud({
        ctr: 'ups', 
        elm: 'user', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then((_d_users) => {
        let _d_vals2 = {
          cm10b11k: _d_users._KEY,
          cm10c110: '',
          cm10i110: _eml,
        }
        cf.myCB_call_iud({
          ctr: 'ins', 
          elm: 'cm10', 
          d_vals: _d_vals2
        })
        .then((_d_cm10s) => {
          _o_end1(_d_cm10s);
        });
      });
    });
  };

  static myRN_user_upd(p_user_key, p_eml){ // 自分自身の場合は、LS の変更も必要
    return new Promise ((resolve)=>{
      let _eml = bf.myCM_cnv('lwr', p_eml);
      let _d_vals = {
        user1010: _eml,
        user1030: _eml,
      }
      let _cnd = bf.q('[_KEY]={}'.f(p_user_key))
      cf.myCB_call_iud({
        ctr: 'upd', 
        elm: 'user', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then(()=>{
        resolve();
      });
    });
  }

  static myRN_prm_stt(p_id='0') { // promise initialize count
    global.c?.setState({
      sgcd_prms: bf.p(global.c?.state.sgcd_prms, _next => {
        _next[p_id] = 0;
      }),
    });
  };

  static myRN_prm_end(p_id='0') { // promise add count
    global.c?.setState({
      sgcd_prms: bf.p(global.c?.state.sgcd_prms, _next => {
        _next[p_id] += 1;
      }),
    });
  };

  static myRN_prm_wait(pn_maxCnt, p_id='0') { // promise add count
    //
    return new Promise( _o_end1 => {
      bf.myCM_clw(0.01, ()=>{
        if (global.c?.state.sgcd_prms[p_id] >= pn_maxCnt) {
          global.c?.setState({
            sgcd_prms: bf.p(global.c?.state.sgcd_prms, _next => {
              delete _next[p_id];
            }),
          });
          return true;
        }
        else {
          return false;
        };
      })
      .then(()=>{
        _o_end1();
      })
    });
  };

  //////////////////////////////////////////////////////////////////////// for message dialog
  static myWD_mdl(p_msg) {
    alert(p_msg,'');
  };

  static myWD_cdl(p_msg, po_fnc1, po_fnc2) {
    Alert.alert(p_msg, '', [{text:'はい', onPress:() => po_fnc1()}, {text:'いいえ', onPress:() => po_fnc2()}]);
  };

  //////////////////////////////////////////////////////////////////////// for websocket

  static myWS_gnr(p_url){ // 常時接続 chn は myWS 経由、ins/upd/rnw は 通常？　基本、全て myWS 経由にし、構造を固める
    return new WebSocket(p_url);
  };

  static myWS_onOpen(p_ws, p_fnc){ // 常時接続 chn は myWS 経由、ins/upd/rnw は 通常？　基本、全て myWS 経由にし、構造を固める
    p_ws.onopen = () => {
      p_fnc();
    };
  };

  static myWS_onRcv(p_ws, p_fnc){ // 常時接続 chn は myWS 経由、ins/upd/rnw は 通常？　基本、全て myWS 経由にし、構造を固める
    p_ws.onmessage = function (_msg) {
      p_fnc(_msg.data);
    };
  };

  static myWS_send_msg(p_ws, p_msg){ // 単発でイベントを発生
    p_ws.send(p_msg);
  };

  static myWS_close(p_ws){ // 単発でイベントを発生
    p_ws.close();
  };

};
